const translations = {
    de: {
        translation: {
            navbar: {
                home: 'Home',
                about: 'Über uns',
                services: 'Leistungen',
                contact: 'Kontakt',
                faq: 'FAQs',
                appointment: 'Jetzt kontaktieren'
            },

            banner: {
                title: 'Ihre Zahnärzte für moderne Zahnmedizin',
                description:
                    'Willkommen in der Gemeinschaftlichen Zahnarztpraxis Pankraz & Lichagin – zu unseren Leistungen gehören prothetische Verfahren mit Implantaten, Kronen und Brücken sowie Teil- und Vollprothesen. Auch ästhetische Behandlungen oder die Parodontitis-Therapie mittels Laser runden unser Leistungsspektrum ab.',
                appointment: 'Jetzt Termin vereinbaren',
                emergency: 'Notdienst',
                emergencyAlt: 'Notdienst',
                imageAlt: 'Zahnarztpraxis'
            },

            services: {
                title: 'Unsere Leistungen',
                description:
                    'Von der regelmäßigen Kontrolle und professionellen Prophylaxe bis hin zu komplexeren zahnmedizinischen Eingriffen: Wir begleiten Sie in jeder Phase Ihrer Behandlung. Gemeinsam besprechen wir die verschiedenen Möglichkeiten, erklären die einzelnen Schritte verständlich und entwickeln eine Behandlung, die zu Ihren persönlichen Bedürfnissen und Vorstellungen passt.',
                show: 'Alle Leistungen anzeigen',
                hide: 'Leistungen ausblenden',

                rootCanal: {
                    title: 'Wurzelbehandlung',
                    description:
                        'Mit einer Wurzelbehandlung kann ein entzündeter oder stark geschädigter Zahn häufig erhalten werden. Dabei werden die Wurzelkanäle gründlich gereinigt, desinfiziert und dicht verschlossen.'
                },

                rootCanalRevision: {
                    title: 'Wurzelbehandlungsrevision',
                    description:
                        'Wenn eine frühere Wurzelbehandlung nicht den gewünschten Erfolg gebracht hat, kann eine Revision notwendig sein. Dabei werden die Wurzelkanäle erneut behandelt, um den Zahn langfristig zu erhalten.'
                },

                fillings: {
                    title: 'Füllungstherapie',
                    description:
                        'Beschädigte oder von Karies betroffene Zähne werden mit hochwertigen Füllungsmaterialien versorgt. So werden Funktion und Ästhetik des Zahnes wiederhergestellt.'
                },

                periodontitis: {
                    title: 'Parodontitisbehandlung',
                    description:
                        'Entzündungen des Zahnfleisches und des Zahnhalteapparates werden frühzeitig behandelt, um den Knochenabbau zu stoppen und die eigenen Zähne langfristig zu erhalten.'
                },

                dentalProsthetics: {
                    title: 'Zahnersatz',
                    description:
                        'Fehlende oder stark beschädigte Zähne werden durch individuellen Zahnersatz ersetzt. Kronen, Brücken und Implantatlösungen sorgen für eine natürliche Funktion und ein harmonisches Erscheinungsbild.'
                },

                dentures: {
                    title: 'Prothesen',
                    description:
                        'Herausnehmbarer Zahnersatz bietet eine zuverlässige Lösung bei mehreren fehlenden Zähnen oder einem zahnlosen Kiefer. Moderne Prothesen überzeugen durch hohen Tragekomfort und eine natürliche Optik.'
                },

                splints: {
                    title: 'Schienen',
                    description:
                        'Individuell angefertigte Zahnschienen schützen die Zähne beispielsweise bei nächtlichem Zähneknirschen oder unterstützen die Kiefergelenke.'
                },

                implants: {
                    title: 'Implantate',
                    description:
                        'Implantate ersetzen fehlende Zähne dauerhaft und bieten eine stabile Basis für Kronen, Brücken oder Prothesen. Sie sorgen für ein natürliches Aussehen, hohen Komfort und eine zuverlässige Kaufunktion.'
                },

                prophylaxis: {
                    title: 'Prophylaxe',
                    description:
                        'Regelmäßige Vorsorge und professionelle Zahnreinigung helfen dabei, Karies und Parodontitis vorzubeugen. So bleiben Ihre Zähne und Ihr Zahnfleisch langfristig gesund.'
                },

                orthodontics: {
                    title: 'Kieferorthopädie',
                    description:
                        'Die Kieferorthopädie beschäftigt sich mit der Korrektur von Zahn- und Kieferfehlstellungen. Mit modernen Behandlungsmethoden sorgen wir für eine funktionelle Bisslage und ein harmonisches Lächeln.'
                },

                moreTitle: 'Weitere Leistungen',

                moreDescription:
                    'Neben den genannten Behandlungen bieten wir Ihnen zahlreiche weitere zahnmedizinische Leistungen an. Gerne beraten wir Sie persönlich und erstellen gemeinsam mit Ihnen ein individuelles Behandlungskonzept, das optimal auf Ihre Bedürfnisse abgestimmt ist.'
            },

            team: {
                subTitle: 'Unser Team',
                title: 'Lernen Sie unser Praxisteam kennen',

                description:
                    'Unser engagiertes Team aus Zahnärzten und zahnmedizinischen Fachangestellten arbeitet Hand in Hand, um Ihnen die bestmögliche Behandlung zu bieten. Freundlichkeit, Kompetenz und Einfühlungsvermögen stehen für uns an erster Stelle, damit Sie sich vom ersten Moment an wohlfühlen.',

                members: {
                    tatjana: {
                        name: 'Frau Tatjana Pankraz',
                        description:
                            'Sie ist seit über 20 Jahren als Zahnärztin tätig und bringt langjährige Berufserfahrung mit – vor allem in der ästhetischen Zahnheilkunde.'
                    },

                    sergey: {
                        name: 'Herr Sergey Lichagin',
                        description:
                            'Er verfügt über langjähriges, umfassendes Know-how und hat sich auf die Bereiche Laser- und Wurzelbehandlungen sowie Implantologie spezialisiert.'
                    },

                    alfiya: {
                        name: 'Frau Alfiya Dyck',
                        description:
                            'Sie ist auf die Schwerpunkte Wurzelkanalbehandlungen und Wurzelkanalrevisionen sowie Kinderzahnheilkunde spezialisiert.'
                    }
                }
            },

            smile: {
                title: 'Wir möchten, dass Sie strahlen.',
                description:
                    'Ihr Lächeln ist uns besonders wichtig – deshalb bieten wir Ihnen eine große Auswahl an Behandlungsmethoden der modernen Zahnheilkunde und unterstützen Sie auch im Bereich der Ästhetik auf dem Weg zu einem strahlenden, gesunden Lächeln.',
                imageAlt: 'Strahlendes Lächeln'
            },

            servicesPreview: {
                subTitle: 'Vorsorge',
                title: 'Vorsorge ist wichtig',

                description:
                    'Regelmäßige Vorsorgeuntersuchungen sind für uns eine gute Chance, Sie als Patienten und Ihren Gesundheitszustand kennenzulernen. Es ist unsere oberste Priorität, Erkrankungen früh zu erkennen und Ihre Gesundheit zu gewährleisten.',

                more: 'Mehr lesen',

                items: {
                    dentalProsthetics: {
                        title: 'Zahnersatz',
                        description:
                            'Die Notwendigkeit von Zahnersatz hat viele Gründe. Deshalb bieten wir individuelle Lösungen, die natürlich aussehen und sich angenehm anfühlen.'
                    },

                    aesthetics: {
                        title: 'Ästhetik',
                        description:
                            'Ihr strahlendes Lächeln ist uns wichtig! Ob Bleaching, Kieferorthopädie oder Inlays – wir bieten Ihnen passende Lösungen für Ihr schönes Lächeln.'
                    },

                    prophylaxis: {
                        title: 'Prophylaxe',
                        description:
                            'Eine auf Ihre Bedürfnisse abgestimmte Prophylaxe kann schädliche Auswirkungen von Bakterien mit geringem Aufwand langfristig verhindern.'
                    },

                    laserTherapy: {
                        title: 'Lasertherapie',
                        description:
                            'Dank moderner Lasertechnologie sind Behandlungen bei uns besonders schonend und schmerzarm. Karies kann präzise entfernt werden – oft sogar ohne Betäubung.'
                    }
                }
            },

            serviceBanner: {
                title: 'Unsere Behandlungen im Überblick',

                description:
                    'Gesunde Zähne sind ein wichtiger Teil Ihres Wohlbefindens. Deshalb verbinden wir bewährte zahnmedizinische Verfahren mit modernen Behandlungsmethoden und legen besonderen Wert auf eine sorgfältige Diagnostik. Ob Vorsorge, Zahnerhalt, Ästhetik oder Zahnersatz – bei uns steht Ihre individuelle Situation im Mittelpunkt.',

                appointment: 'Jetzt Termin vereinbaren',
                imageAlt: 'Unsere Behandlungen'
            },

            partners: {
                subTitle: 'Unsere Partner',
                title: 'Starke Partner für Ihr Lächeln',

                description:
                    'Damit wir Ihnen Ihr schönstes Lächeln ermöglichen können, arbeiten wir mit starken Partnern aus vielfältigen Bereichen der Zahnmedizin zusammen. Egal, ob moderne Kieferorthopädie, professionelles Bleaching oder innovative Lasertechnologie – einen Überblick über unsere Partner erhalten Sie hier.',

                items: {
                    claire: {
                        title: 'Model Claire Aligner',
                        description:
                            'Die modernen Claire Aligner ermöglichen eine unauffällige und komfortable Zahnkorrektur – effektiv, präzise und alltagstauglich.'
                    },

                    philips: {
                        title: 'Philips',
                        description:
                            'Mit Philips ZOOM! bieten wir eine schonende Zahnaufhellung für sichtbar hellere Zähne – schnell, sicher und langanhaltend.'
                    },

                    dmg: {
                        title: 'DMG',
                        description:
                            'Die Kariesinfiltration mit Icon® entfernt White Spots schonend – ganz ohne Bohren, Schmerzen oder Betäubung.'
                    },

                    biolase: {
                        title: 'Biolase',
                        description:
                            'Das moderne Waterlase iPlus Dental System ermöglicht besonders schonende und nahezu schmerzfreie Behandlungen mit innovativer Lasertechnologie.'
                    }
                }
            },

            priority: {
                subTitle: 'UNSERE WERTE',
                title: 'Vertrauen, Kompetenz und Qualität für Ihr Lächeln',

                description:
                    'Mit Erfahrung, moderner Technik und regelmäßigen Fortbildungen sorgen wir dafür, dass Sie sich bei jedem Besuch gut aufgehoben fühlen. Ob Vorsorge, Zahnerhalt, ästhetische Zahnmedizin oder Zahnersatz – wir begleiten Sie kompetent und einfühlsam auf dem Weg zu einem gesunden und schönen Lächeln.\n\nFür uns stehen Vertrauen, Offenheit und eine verständliche Beratung an erster Stelle. Wir nehmen uns Zeit für Ihre Fragen und entwickeln gemeinsam mit Ihnen die passende Behandlung.\n\nWir freuen uns darauf, Sie in unserer Praxis begrüßen zu dürfen!',

                appointment: 'Termin vereinbaren',
                imageAlt: 'Unsere Werte'
            },

            more: {
                title: 'Möchten Sie mehr wissen?',

                description:
                    'Tatjana Pankraz, Sergej Lichagin und Alfiya Dyck stehen Ihnen als eingespieltes Team bei allen Fragen gerne zur Verfügung.',

                email: 'Per E-Mail',
                phone: 'Telefonisch',
                personal: 'Persönlich vor Ort',
                imageAlt: 'Unser Expertenteam'
            },

            gallery: {
                subTitle: 'Einblicke in unsere Praxis',
                title: 'Impressionen aus unserer Praxis',

                description:
                    'Entdecken Sie unsere Praxis und gewinnen Sie einen Eindruck von unseren modernen Behandlungsräumen, innovativer Technik und einer freundlichen Atmosphäre.',

                imageAlt: 'Einblick in unsere Zahnarztpraxis'
            },

                        footer: {
                description:
                    'Gesunde Zähne, ein strahlendes Lächeln und eine persönliche Betreuung – dafür stehen wir. Wir verbinden moderne Behandlungsmethoden mit einer angenehmen Atmosphäre und nehmen uns Zeit für Ihre individuellen Wünsche.',

                followUs: 'Folgen Sie uns',
                contactTitle: 'Kontakt & Information',

                contacts: {
                    phoneEmail: {
                        title: 'Telefonnummer und E-Mail'
                    },

                    openingHours: {
                        title: 'Öffnungszeiten',
                        info: 'Mo–Do: 08:30–13:00 und 14:30–19:00 Uhr, Fr: 08:30–14:00 Uhr'
                    },

                    address: {
                        title: 'Adresse'
                    }
                },

                copyright: 'Alle Rechte vorbehalten.',

                links: {
                    privacy: 'Datenschutzerklärung',
                    imprint: 'Impressum',
                    cookies: 'Cookie-Einstellungen'
                }
            },

            faq: {
    title: 'Fragen & Antworten',

    description:
        'Hier finden Sie Antworten auf häufige Fragen rund um Zahngesundheit, Prophylaxe und unsere Behandlungen.',

    items: [
        {
            question:
                'Warum ist eine professionelle Zahnreinigung sinnvoll, wenn ich meine Zähne zu Hause gut pflege?',
            answer:
                'Eine sorgfältige Zahnpflege zu Hause ist die wichtigste Grundlage für gesunde Zähne und gesundes Zahnfleisch. Trotzdem gibt es Bereiche, die sich auch bei guter Mundhygiene nur schwer vollständig reinigen lassen. Bei der professionellen Zahnreinigung entfernen wir weiche und harte Beläge – auch an schwer zugänglichen Stellen. Dadurch lässt sich das Risiko für Karies und Zahnfleischerkrankungen reduzieren und die Mundgesundheit langfristig unterstützen.'
        },

        {
            question:
                'Wie oft sollte ich eine professionelle Zahnreinigung durchführen lassen?',
            answer:
                'Für viele Patientinnen und Patienten ist ein Abstand von etwa sechs Monaten sinnvoll. Einen allgemeingültigen Rhythmus gibt es jedoch nicht. Bei Zahnfleischerkrankungen, verstärkter Zahnsteinbildung, Implantaten oder bestimmten Formen von Zahnersatz können kürzere Intervalle – beispielsweise alle drei bis vier Monate – empfehlenswert sein. Welcher Abstand für Sie sinnvoll ist, besprechen wir individuell mit Ihnen.'
        },

        {
            question:
                'Warum benötigen Implantate, Kronen und Brücken besonders sorgfältige Pflege?',
            answer:
                'Auch hochwertiger Zahnersatz benötigt eine konsequente Pflege. Insbesondere an Übergängen und schwer erreichbaren Stellen können sich bakterielle Beläge ansammeln. Eine regelmäßige professionelle Reinigung hilft dabei, Zahnfleisch und das Gewebe rund um Implantate gesund zu erhalten und unterstützt die langfristige Haltbarkeit Ihrer Versorgung.'
        },

        {
            question:
                'Was kostet eine professionelle Zahnreinigung?',
            answer:
                'Eine professionelle Zahnreinigung kostet in unserer Praxis ab 120 Euro. Der genaue Preis richtet sich nach dem Zustand von Zähnen und Zahnfleisch, der Menge der vorhandenen Beläge und dem individuellen Behandlungsaufwand.'
        },

        {
            question:
                'Welche Füllungen und Restaurationen bieten Sie an?',
            answer:
                'Je nach Zahnsituation arbeiten wir mit modernen Kompositmaterialien und keramischen Restaurationen. Für kleinere und mittlere Defekte kann eine ästhetische Kompositversorgung sehr gut geeignet sein. Bei größeren Defekten kann eine keramische Restauration durch ihre Stabilität und Langlebigkeit Vorteile bieten. Welche Versorgung sinnvoll ist, entscheiden wir nicht pauschal, sondern anhand des betroffenen Zahnes, der Belastung, der Größe des Defektes und Ihrer persönlichen Wünsche.'
        },

        {
            question:
                'Was ist besser – Komposit oder Keramik?',
            answer:
                'Das hängt von der jeweiligen Situation ab. Moderne Komposite ermöglichen eine substanzschonende und ästhetische Versorgung. Keramische Restaurationen eignen sich besonders dann, wenn eine hohe Stabilität, Form- und Farbbeständigkeit sowie eine langfristige Versorgung größerer Defekte gefragt sind. Unser Ziel ist es, möglichst viel gesunde Zahnsubstanz zu erhalten und die Lösung zu wählen, die für Ihren Zahn medizinisch sinnvoll ist.'
        },

        {
            question:
                'Wie lange halten Komposit- und Keramikrestaurationen?',
            answer:
                'Die Lebensdauer lässt sich nicht exakt vorhersagen. Sie hängt unter anderem von Größe und Lage der Restauration, der Kaubelastung, Ihrer Mundhygiene und den regelmäßigen Kontroll- und Prophylaxeterminen ab. Als Orientierung können Kompositrestaurationen bei guter Pflege häufig 5 bis 10 Jahre, keramische Restaurationen 10 bis 15 Jahre oder länger halten.'
        },

        {
            question:
                'Was kostet eine Füllung?',
            answer:
                'Die Kosten richten sich nach Größe und Lage des Defektes, dem verwendeten Material und dem notwendigen Aufwand. Die Zuzahlung für eine Kompositversorgung beginnt bei 20 Euro, für eine keramische Versorgung bei 75 Euro. Vor der Behandlung erklären wir Ihnen, welche Möglichkeiten in Ihrem Fall bestehen und mit welchen Kosten sie verbunden sind.'
        },

        {
            question:
                'Warum muss ich bei manchen Füllungen zuzahlen?',
            answer:
                'Gesetzlich Versicherte haben Anspruch auf eine zuzahlungsfreie Versorgung im Rahmen der gesetzlichen Krankenversicherung. Entscheiden Sie sich für eine aufwendigere oder ästhetisch anspruchsvollere Versorgung, die über die Kassenleistung hinausgeht, können Mehrkosten entstehen. Welche Alternativen es gibt und welche Kosten damit verbunden sind, besprechen wir selbstverständlich vor Beginn der Behandlung mit Ihnen.'
        },

        {
            question:
                'Wann ist eine Wurzelkanalbehandlung notwendig?',
            answer:
                'Eine Wurzelkanalbehandlung kann notwendig werden, wenn das Gewebe im Inneren eines Zahnes entzündet oder infiziert ist. Ziel der Behandlung ist es, die Entzündung zu beseitigen und den eigenen Zahn möglichst zu erhalten. Nach einer sorgfältigen Diagnostik beurteilen wir, ob der Zahnerhalt in Ihrem Fall medizinisch sinnvoll und erfolgversprechend ist.'
        },

        {
            question:
                'Was kostet eine Wurzelkanalbehandlung?',
            answer:
                'Die Kosten hängen insbesondere von der Anatomie des Zahnes, der Anzahl der Wurzelkanäle und dem Behandlungsaufwand ab. Als Orientierung: 1 Wurzelkanal ab 200 Euro, 3 oder mehr Wurzelkanäle ab 300 Euro. Nach der Diagnostik können wir den notwendigen Umfang genauer einschätzen und informieren Sie vorab über die zu erwartenden Kosten.'
        },

        {
            question:
                'Wann ist ein Implantat eine gute Lösung?',
            answer:
                'Ein Implantat kann einen fehlenden Zahn ersetzen, ohne dass dafür gesunde Nachbarzähne beschliffen werden müssen. Implantate können außerdem als stabile Basis für Brücken oder Prothesen dienen. Ein Implantat ist jedoch nicht automatisch in jeder Situation die beste Lösung. Wir beurteilen den Zustand der Nachbarzähne, des Zahnfleisches und des Kieferknochens und besprechen mögliche Alternativen mit Ihnen.'
        },

        {
            question:
                'Was kostet ein Zahnimplantat?',
            answer:
                'Die Kosten für ein Implantat beginnen in unserer Praxis bei 1.200 Euro. Der endgültige Preis hängt von der individuellen Ausgangssituation, dem vorhandenen Knochenangebot, eventuell notwendigen vorbereitenden Maßnahmen und der geplanten prothetischen Versorgung ab. Deshalb kann ein genauer Kostenplan erst nach Untersuchung und Diagnostik erstellt werden. Vor Behandlungsbeginn erhalten Sie eine transparente Übersicht über die zu erwartenden Kosten.'
        },

        {
            question:
                'Wann ist eine Knirscherschiene sinnvoll?',
            answer:
                'Wer nachts stark mit den Zähnen presst oder knirscht, kann seine Zähne dauerhaft überlasten und abnutzen. Auch Kaumuskulatur und Kiefergelenke können dadurch belastet werden. Eine individuell angefertigte Schiene kann die Zähne schützen und dabei helfen, die Belastung gleichmäßiger zu verteilen.'
        },

        {
            question:
                'Was ist der Unterschied zwischen einer Knirscherschiene und einer adjustierten Schiene?',
            answer:
                'Welche Schiene sinnvoll ist, hängt von Ihrer individuellen Situation ab. Eine adjustierte Schiene wird gezielt an die Kontakte zwischen Ober- und Unterkiefer angepasst. Sie dient damit nicht nur als Schutzschicht zwischen den Zähnen, sondern ermöglicht eine kontrolliertere Verteilung der Belastung. Nach der Untersuchung können wir beurteilen, welche Form der Schienentherapie für Sie sinnvoll ist. Eine individuell angepasste Schiene ist ab 60 Euro erhältlich.'
        },

        {
            question:
                'Erfahre ich die Behandlungskosten im Voraus?',
            answer:
                'Ja. Bei kleineren Behandlungen können wir Ihnen die Kosten beziehungsweise die mögliche Zuzahlung direkt erläutern. Bei umfangreicheren Behandlungen erstellen wir einen individuellen Behandlungs- und Kostenplan. Uns ist wichtig, dass Sie nicht nur wissen, was wir empfehlen, sondern auch warum, welche Alternativen bestehen und welche Kosten damit verbunden sind. Bei Beträgen bis 150 Euro erfolgt die Zahlung direkt nach der Behandlung. Bei höheren Beträgen können Sie auf Wunsch eine Rechnung zur späteren Zahlung erhalten.'
        },

        {
            question:
                'Kann eine Zahnzusatzversicherung meine Behandlungskosten übernehmen?',
            answer:
                'Je nach Tarif kann eine Zahnzusatzversicherung Kosten für professionelle Zahnreinigungen, hochwertige Restaurationen, Kronen, Brücken, Implantate und weitere zahnmedizinische Leistungen teilweise oder vollständig übernehmen. Die Leistungen unterscheiden sich jedoch erheblich. Erstattungssätze, jährliche Höchstbeträge, Wartezeiten und Ausschlüsse richten sich nach Ihrem persönlichen Versicherungsvertrag. Daher können wir keine verbindliche Aussage darüber treffen, welchen Betrag Ihre Versicherung tatsächlich übernimmt.'
        },

        {
            question:
                'Wie erfahre ich vor der Behandlung, was meine Versicherung übernimmt?',
            answer:
                'Bei umfangreicheren Behandlungen können wir Ihnen einen Behandlungs- und Kostenplan erstellen, den Sie vor Behandlungsbeginn bei Ihrer Versicherung einreichen können. So können Sie die voraussichtliche Erstattung vorab klären und Ihre Entscheidung in Ruhe treffen. Wenn Sie erst über den Abschluss einer Zahnzusatzversicherung nachdenken, lohnt sich ein genauer Blick auf die Vertragsbedingungen: Bereits angeratene, geplante oder begonnene Behandlungen werden von vielen Tarifen nicht oder nur eingeschränkt übernommen.'
        }
    ]
},
appointment: {
    map: {
        title: 'Google Maps',
        description:
            'Um die Karte anzuzeigen, müssen Sie Google Maps in den Cookie-Einstellungen aktivieren.',
        cookieSettings: 'Cookie-Einstellungen'
    },

    form: {
        subTitle: 'Schreiben Sie uns',
        title: 'Wir unterstützen Sie gerne bei allen Fragen',
        description:
            'Wenn Sie Fragen haben, schreiben Sie uns gerne. Bitte füllen Sie alle unten stehenden Informationen aus und senden Sie das Formular ab. Wir antworten Ihnen so schnell wie möglich.'
    }
},
aboutBanner: {
    title: 'Über uns',

    description:
        'Willkommen in der Zahnarztpraxis Pankraz & Lichagin! Unsere Praxis steht für moderne Zahnmedizin, persönliche Betreuung und eine angenehme Atmosphäre. Unser Ziel ist es, jedem Patienten eine individuelle Behandlung auf höchstem fachlichen Niveau zu bieten.',

    button: 'Kontaktieren Sie uns!',

    imageAlt: 'Zahnarztpraxis Pankraz & Lichagin',

    imageAltTwo: 'Behandlungsräume der Zahnarztpraxis'
},
contactPage: {
    title: 'Kontaktieren Sie uns',

    description:
        'Wir sind gerne für Sie da. Ob Terminvereinbarung, Fragen zu unseren Behandlungen oder ein zahnmedizinischer Notfall – unser Team unterstützt Sie kompetent und freundlich. Nehmen Sie Kontakt mit uns auf – wir freuen uns auf Ihre Nachricht.',

    appointmentText:
        'Sie möchten direkt einen Termin vereinbaren?',

    appointmentTextSecond:
        'Nutzen Sie einfach unsere Online-Terminvereinbarung.',

    appointmentButton:
        'Jetzt Termin vereinbaren',

    formText:
        'Sie haben noch Fragen oder möchten uns lieber direkt schreiben?',

    formTextSecond:
        'Nutzen Sie gerne unser Kontaktformular – wir melden uns schnellstmöglich bei Ihnen.'
},
notFound: {
    subtitle: 'Seite nicht gefunden',

    title: 'Diese Seite wurde nicht gefunden.',

    description:
        'Die gewünschte Seite existiert nicht oder wurde verschoben. Kehren Sie zur Startseite zurück und entdecken Sie unsere Praxis.',

    button: 'Zur Startseite'
},
contactForm: {
    name: {
        label: 'Vor- und Nachname',
        placeholder: 'Ihr Name'
    },

    email: {
        label: 'E-Mail-Adresse',
        placeholder: 'Ihre E-Mail-Adresse'
    },

    birthday: {
        label: 'Geburtsdatum',
        placeholder: 'TT.MM.JJJJ'
    },

    subject: {
        label: 'Betreff',
        placeholder: 'Bitte auswählen',

        options: {
            appointment: 'Terminvereinbarung',
            treatment: 'Frage zur Behandlung',
            emergency: 'Notfall',
            costs: 'Kostenanfrage',
            other: 'Sonstiges'
        }
    },

    message: {
        label: 'Nachricht',
        placeholder: 'Schreiben Sie uns Ihre Nachricht...'
    },

    sending: 'Wird gesendet...',

    send: 'Nachricht senden',

    successMessage:
        'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns schnellstmöglich bei Ihnen melden.',

    errorMessage:
        'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
},
cookies: {
            title: 'Cookie-Einstellungen',

            description:
                'Wir verwenden Cookies und ähnliche Technologien, um unsere Website sicher und funktionsfähig bereitzustellen. Einige externe Dienste werden nur nach Ihrer Einwilligung geladen.',

            moreInfo:
                'Weitere Informationen finden Sie in unserer',

            privacy:
                'Datenschutzerklärung',

            buttons: {
                necessary: 'Nur notwendige',
                settings: 'Einstellungen',
                acceptAll: 'Alle akzeptieren',
                save: 'Auswahl speichern'
            },

            settings: {
                alwaysActive: 'Immer aktiv',

                necessary: {
                    title: 'Notwendige Cookies',
                    description:
                        'Diese Cookies sind erforderlich, damit unsere Website ordnungsgemäß funktioniert.'
                },

                googleMaps: {
                    title: 'Google Maps',
                    description:
                        'Ermöglicht die Anzeige von Google Maps und unseres Praxisstandortes.'
                },

                instagram: {
                    title: 'Instagram',
                    description:
                        'Ermöglicht die Anzeige von Instagram-Inhalten.'
                },

                tracking: {
                    title: 'Statistik & Tracking',
                    description:
                        'Hilft uns zu verstehen, wie Besucher unsere Website nutzen.'
                },

                marketing: {
                    title: 'Marketing',
                    description:
                        'Ermöglicht die Nutzung von Marketing- und Werbediensten.'
                }
            }
        },
        datenschutz: {
    hero: {
        eyebrow: "Rechtliche Informationen",
        title: "Datenschutz",
        text: "Der Schutz Ihrer persönlichen Daten ist uns wichtig. Hier erfahren Sie, wie wir mit Ihren personenbezogenen Daten umgehen."
    },

    sections: {
        responsible: {
            title: "1. Verantwortlicher",
            intro: "Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:"
        },

        general: {
            title: "2. Allgemeine Hinweise",
            p1: "Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.",
            p2: "Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Hierzu gehören beispielsweise Name, E-Mail-Adresse, Telefonnummer, IP-Adresse oder andere Informationen, die mit Ihrer Person in Verbindung gebracht werden können.",
            p3: "Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website, zur Bearbeitung Ihrer Anfragen, zur Erfüllung gesetzlicher Verpflichtungen oder aufgrund einer von Ihnen erteilten Einwilligung erforderlich ist."
        },

        website: {
            title: "3. Datenverarbeitung beim Besuch unserer Website",
            p1: "Beim Aufrufen unserer Website werden durch den von Ihnen verwendeten Browser automatisch Informationen an den Server unserer Website übermittelt.",
            intro: "Hierbei können insbesondere folgende Daten verarbeitet werden:",
            items: {
                ip: "IP-Adresse des zugreifenden Geräts",
                date: "Datum und Uhrzeit des Zugriffs",
                pages: "aufgerufene Webseiten",
                browser: "Browsertyp und Browserversion",
                os: "Betriebssystem",
                referrer: "Referrer-URL",
                connection: "technische Verbindungsdaten"
            },
            p2: "Die Verarbeitung dieser Daten erfolgt insbesondere zur technischen Bereitstellung, Stabilität und Sicherheit unserer Website.",
            legal: "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO."
        },

        hosting: {
            title: "4. Hosting über ALL-INKL.COM",
            p1: "Diese Website wird bei der ALL-INKL.COM – Neue Medien Münnich, Inhaber René Münnich, Hauptstraße 68, 02742 Friedersdorf, Deutschland gehostet.",
            p2: "ALL-INKL.COM stellt die technische Infrastruktur für die Bereitstellung unserer Website zur Verfügung. Im Rahmen des Hostings können personenbezogene Daten verarbeitet werden, die beim Besuch unserer Website technisch anfallen.",
            p3: "Hierzu können insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten, Browserinformationen, Betriebssystem, Referrer-URL sowie technische Verbindungsdaten gehören.",
            p4: "Die Verarbeitung dieser Daten dient insbesondere der technischen Bereitstellung, Stabilität und Sicherheit unserer Website.",
            p5: "Soweit ALL-INKL.COM personenbezogene Daten in unserem Auftrag verarbeitet, erfolgt dies auf Grundlage einer Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO.",
            p6: "Die Datenverarbeitung im Rahmen des Webhostings erfolgt grundsätzlich in Deutschland. ALL-INKL.COM gibt an, dass die für das Webhosting eingesetzte Rechenzentrumsinfrastruktur in Deutschland betrieben wird.",
            link: "Datenschutzinformationen von ALL-INKL.COM"
        },

        contact: {
            title: "5. Kontaktaufnahme",
            p1: "Wenn Sie uns per E-Mail, Telefon oder über unser Kontaktformular kontaktieren, werden die von Ihnen mitgeteilten personenbezogenen Daten verarbeitet, soweit dies zur Bearbeitung Ihrer Anfrage erforderlich ist.",
            intro: "Hierzu können insbesondere folgende Daten gehören:",
            items: {
                name: "Name",
                email: "E-Mail-Adresse",
                phone: "Telefonnummer",
                message: "Inhalt Ihrer Nachricht",
                time: "Zeitpunkt der Kontaktaufnahme"
            },
            p2: "Die Verarbeitung erfolgt zur Bearbeitung und Beantwortung Ihrer Anfrage.",
            legal: "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Anbahnung oder Durchführung eines Vertragsverhältnisses zusammenhängt. In anderen Fällen erfolgt die Verarbeitung auf Grundlage unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO."
        },

        contactForm: {
            title: "6. Kontaktformular",
            p1: "Auf unserer Website besteht die Möglichkeit, über ein Kontaktformular mit uns in Verbindung zu treten.",
            p2: "Die von Ihnen eingegebenen Daten werden zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme mit Ihnen verarbeitet.",
            p3: "Wir bitten Sie, über das allgemeine Kontaktformular keine unnötigen Gesundheitsdaten oder andere besonders geschützte personenbezogene Daten zu übermitteln.",
            p4: "Gesundheitsdaten gehören gemäß Art. 9 DSGVO zu den besonderen Kategorien personenbezogener Daten und genießen einen erhöhten Schutz."
        },

        email: {
            title: "7. Technischer E-Mail-Versand",
            p1: "Für die technische Übermittlung von Nachrichten aus unserem Kontaktformular kann ein externer E-Mail-Dienst eingesetzt werden.",
            p2: "Soweit hierfür EmailJS eingesetzt wird, können die von Ihnen im Kontaktformular eingegebenen Daten zum Zweck der technischen Übermittlung Ihrer Nachricht verarbeitet werden.",
            p3: "Die Verarbeitung erfolgt ausschließlich zur Bearbeitung Ihrer Kontaktanfrage."
        },

        googleMaps: {
            title: "8. Google Maps",
            p1: "Auf unserer Website kann Google Maps zur Darstellung unseres Praxisstandortes eingebunden sein.",
            p2: "Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.",
            p3: "Bei der Nutzung von Google Maps können insbesondere Ihre IP-Adresse sowie weitere technische Informationen an Google übertragen werden.",
            p4: "Die Einbindung von Google Maps dient dazu, Ihnen unseren Standort übersichtlich darzustellen und die Anfahrt zu unserer Praxis zu erleichtern.",
            p5: "Soweit gesetzlich erforderlich, wird Google Maps erst nach Ihrer Einwilligung geladen.",
            link: "Datenschutzerklärung von Google"
        },

        instagram: {
            title: "9. Instagram",
            p1: "Auf unserer Website befindet sich ein Link zu unserem Instagram-Auftritt.",
            p2: "Durch die reine Verlinkung werden beim Besuch unserer Website grundsätzlich keine personenbezogenen Daten an Instagram übertragen.",
            p3: "Wenn Sie den Instagram-Link anklicken, werden Sie zu Instagram weitergeleitet. Ab diesem Zeitpunkt gelten die Datenschutzbestimmungen des jeweiligen Anbieters.",
            p4: "Anbieter von Instagram ist Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.",
            link: "Datenschutzrichtlinie von Instagram"
        },

        cookies: {
            title: "10. Cookies",
            p1: "Unsere Website verwendet Cookies und vergleichbare Technologien, soweit dies für den Betrieb der Website erforderlich oder gesetzlich zulässig ist.",
            p2: "Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden können.",
            p3: "Technisch notwendige Cookies können erforderlich sein, damit unsere Website ordnungsgemäß funktioniert.",
            p4: "Für nicht notwendige Cookies und vergleichbare Technologien holen wir, soweit gesetzlich erforderlich, zuvor Ihre Einwilligung ein.",
            p5: "Sie können Ihre Cookie-Einstellungen jederzeit über unsere entsprechende Seite ändern.",
            link: "Cookie-Einstellungen öffnen"
        },

        storage: {
            title: "11. Speicherdauer",
            p1: "Wir speichern personenbezogene Daten nur so lange, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
            p2: "Nach Wegfall des jeweiligen Verarbeitungszwecks werden die Daten gelöscht, sofern keine gesetzlichen Gründe einer weiteren Speicherung entgegenstehen."
        },

        rights: {
            title: "12. Ihre Rechte",
            intro: "Sie haben im Rahmen der gesetzlichen Vorschriften insbesondere folgende Rechte:",
            items: {
                access: "Recht auf Auskunft",
                rectification: "Recht auf Berichtigung",
                deletion: "Recht auf Löschung",
                restriction: "Recht auf Einschränkung der Verarbeitung",
                portability: "Recht auf Datenübertragbarkeit",
                objection: "Recht auf Widerspruch",
                withdrawal: "Recht auf Widerruf einer erteilten Einwilligung"
            },
            p1: "Wenn Sie von Ihren Rechten Gebrauch machen möchten, können Sie sich jederzeit über die oben genannten Kontaktdaten an uns wenden."
        },

        complaint: {
            title: "13. Beschwerderecht bei einer Aufsichtsbehörde",
            p1: "Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen datenschutzrechtliche Vorschriften verstößt.",
            authority: "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen"
        },

        security: {
            title: "14. Datensicherheit",
            p1: "Wir setzen angemessene technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre personenbezogenen Daten vor Verlust, Zerstörung, Manipulation oder dem Zugriff unberechtigter Personen zu schützen.",
            p2: "Unsere Sicherheitsmaßnahmen werden entsprechend der technischen Entwicklung und den gesetzlichen Anforderungen regelmäßig überprüft und angepasst."
        },

        externalLinks: {
            title: "15. Externe Links",
            p1: "Unsere Website kann Links zu externen Websites und Online-Angeboten Dritter enthalten.",
            p2: "Auf die Inhalte und die Datenverarbeitung auf diesen externen Websites haben wir keinen Einfluss. Für die Verarbeitung personenbezogener Daten durch diese Anbieter gelten die jeweiligen Datenschutzbestimmungen der Betreiber."
        },

        changes: {
            title: "16. Änderungen dieser Datenschutzerklärung",
            p1: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich die technischen Gegebenheiten unserer Website oder die gesetzlichen Anforderungen ändern.",
            p2: "Die jeweils aktuelle Version dieser Datenschutzerklärung ist auf unserer Website abrufbar."
        }
    },

    updated: "Stand: August 2026"
},
impressum: {
    title: "Impressum",

    ddg: {
        title: "Angaben gemäß § 5 DDG"
    },

    contact: {
        title: "Kontakt",
        phone: "Tel: 0521-7708288",
        fax: "Fax: 0521-7708290",
        email: "E-Mail: info@zahnarztpraxispankrazlichagin.com"
    },

    chamber: {
        title: "Zuständige Kammer",
        text: "Zahnärztekammer Westfalen-Lippe"
    },

    approval: {
        title: "Staat der Approbation",
        text: "Deutschland"
    },

    professionalRules: {
        title: "Berufsrechtliche Regelungen",
        p1: "Berufsrechtliche Regelungen der Zahnärztekammer Westfalen-Lippe.",
        p2: "Die berufsrechtlichen Regelungen können auf der Website der Zahnärztekammer Westfalen-Lippe eingesehen werden."
    },

    responsible: {
        title: "Inhaltlich verantwortlich"
    },

    vat: "Wir sind nicht umsatzsteuerpflichtig.",

    liability: {
        title: "Haftungsausschluss",

        content: {
            title: "1. Inhalt des Onlineangebotes",
            p1: "Der Betreiber der Webseite übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Betreiber der Webseite, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Betreibers der Webseite kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.",
            p2: "Alle Angebote sind freibleibend und unverbindlich. Der Betreiber der Webseite behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen."
        },

        links: {
            title: "2. Verweise und Links",
            p1: "Bei direkten oder indirekten Verweisen auf fremde Webseiten (\"Hyperlinks\"), die außerhalb des Verantwortungsbereiches des Betreibers der Webseite liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Betreiber der Webseite von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.",
            p2: "Der Betreiber der Webseite erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten/verknüpften Seiten hat der Betreiber der Webseite keinerlei Einfluss.",
            p3: "Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller gelinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden.",
            p4: "Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Betreiber der Webseite eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten.",
            p5: "Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist."
        }
    },

    copyright: {
        title: "3. Urheber- und Kennzeichenrecht",
        p1: "Der Betreiber der Webseite ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.",
        p2: "Das Copyright für veröffentlichte, vom Betreiber der Webseite selbst erstellte Objekte bleibt allein beim Betreiber der Webseite. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Betreibers der Webseite nicht gestattet.",
        p3: "Der Betreiber der Webseite dieser Homepage ist weder für direkte noch indirekte Schäden, die durch Benutzung dieser Homepage für den Benutzer oder Dritte entstehen, verantwortlich."
    }
},

            whatsapp: {
                title: "Lieber per WhatsApp?",
                description:
                    "Sie haben Fragen oder möchten einen Termin vereinbaren? Kontaktieren Sie uns ganz einfach über unseren WhatsApp-Service.",
                instruction: "QR-Code scannen und Chat starten.",
                button: "WhatsApp-Chat starten",
                phoneLabel: "WhatsApp-Nummer",
                qrAlt: "QR-Code zum Öffnen unseres WhatsApp-Chats"
            },

    },
    },

















    en: {
        translation: {
            navbar: {
                home: 'Home',
                about: 'About us',
                services: 'Services',
                contact: 'Contact',
                faq: 'FAQs',
                appointment: 'Contact us'
            },

            banner: {
                title: 'Your dentists for modern dental care',
                description:
                    'Welcome to the Pankraz & Lichagin Dental Practice. Our services include prosthetic treatments with implants, crowns and bridges, as well as partial and full dentures. Aesthetic treatments and laser-assisted periodontal therapy complete our range of services.',
                appointment: 'Book an appointment',
                emergency: 'Emergency dental service',
                emergencyAlt: 'Emergency dental service',
                imageAlt: 'Dental practice'
            },

            services: {
                title: 'Our Services',

                description:
                    'From regular check-ups and professional preventive care to more complex dental procedures, we support you throughout every stage of your treatment. Together, we discuss the available options, explain each step clearly and develop a treatment plan tailored to your individual needs and expectations.',

                show: 'Show all services',
                hide: 'Hide services',

                rootCanal: {
                    title: 'Root Canal Treatment',
                    description:
                        'Root canal treatment can often save an inflamed or severely damaged tooth. The root canals are thoroughly cleaned, disinfected and securely sealed.'
                },

                rootCanalRevision: {
                    title: 'Root Canal Retreatment',
                    description:
                        'If a previous root canal treatment was not successful, retreatment may be necessary. The root canals are treated again to help preserve the tooth in the long term.'
                },

                fillings: {
                    title: 'Dental Fillings',
                    description:
                        'Damaged or decayed teeth are restored using high-quality filling materials. This helps restore both the function and appearance of the tooth.'
                },

                periodontitis: {
                    title: 'Periodontal Treatment',
                    description:
                        'Inflammation of the gums and supporting structures of the teeth is treated at an early stage to help stop bone loss and preserve your natural teeth in the long term.'
                },

                dentalProsthetics: {
                    title: 'Dental Prosthetics',
                    description:
                        'Missing or severely damaged teeth can be replaced with individually designed dental restorations. Crowns, bridges and implant-supported solutions provide natural function and an attractive appearance.'
                },

                dentures: {
                    title: 'Dentures',
                    description:
                        'Removable dentures provide a reliable solution when several teeth are missing or the jaw is completely toothless. Modern dentures offer high comfort and a natural appearance.'
                },

                splints: {
                    title: 'Dental Splints',
                    description:
                        'Custom-made dental splints can protect the teeth, for example from nighttime teeth grinding, and can also support the jaw joints.'
                },

                implants: {
                    title: 'Dental Implants',
                    description:
                        'Dental implants permanently replace missing teeth and provide a stable foundation for crowns, bridges or dentures. They offer a natural appearance, high comfort and reliable chewing function.'
                },

                prophylaxis: {
                    title: 'Preventive Care',
                    description:
                        'Regular check-ups and professional teeth cleaning help prevent tooth decay and periodontal disease. This helps keep your teeth and gums healthy in the long term.'
                },

                orthodontics: {
                    title: 'Orthodontics',
                    description:
                        'Orthodontics focuses on correcting misaligned teeth and jaws. Modern treatment methods help achieve a functional bite and a harmonious smile.'
                },

                moreTitle: 'Additional Services',

                moreDescription:
                    'In addition to the treatments mentioned above, we offer a wide range of other dental services. We are happy to provide you with personal advice and develop an individual treatment plan tailored to your needs.'
            },

            team: {
                subTitle: 'Our Team',
                title: 'Meet Our Dental Team',

                description:
                    'Our dedicated team of dentists and dental professionals works closely together to provide you with the best possible treatment. Friendliness, expertise and empathy are our top priorities, so that you feel comfortable and well cared for from the very beginning.',

                members: {
                    tatjana: {
                        name: 'Ms. Tatjana Pankraz',
                        description:
                            'She has been working as a dentist for more than 20 years and brings extensive professional experience, particularly in aesthetic dentistry.'
                    },

                    sergey: {
                        name: 'Mr. Sergey Lichagin',
                        description:
                            'He has extensive professional knowledge and many years of experience, with a particular focus on laser treatments, root canal treatments and implantology.'
                    },

                    alfiya: {
                        name: 'Ms. Alfiya Dyck',
                        description:
                            'She specializes in root canal treatments and root canal retreatments as well as pediatric dentistry.'
                    }
                }
            },

            smile: {
                title: 'We want you to smile with confidence.',
                description:
                    'Your smile is especially important to us. That is why we offer a wide range of modern dental treatments and support you in the field of aesthetic dentistry on your way to a healthy, beautiful and confident smile.',
                imageAlt: 'Beautiful smile'
            },

            servicesPreview: {
                subTitle: 'Prevention',
                title: 'Prevention is important',

                description:
                    'Regular preventive examinations give us a valuable opportunity to get to know you as a patient and assess your dental health. Our top priority is to detect diseases at an early stage and help maintain your oral health.',

                more: 'Read more',

                items: {
                    dentalProsthetics: {
                        title: 'Dental Prosthetics',
                        description:
                            'There are many reasons why dental prosthetics may be necessary. We therefore offer individual solutions that look natural and feel comfortable.'
                    },

                    aesthetics: {
                        title: 'Aesthetic Dentistry',
                        description:
                            'Your beautiful smile is important to us! Whether you are interested in teeth whitening, orthodontics or inlays, we offer suitable solutions for your individual smile.'
                    },

                    prophylaxis: {
                        title: 'Preventive Care',
                        description:
                            'Preventive care tailored to your individual needs can help prevent the harmful effects of bacteria with minimal effort and maintain your oral health in the long term.'
                    },

                    laserTherapy: {
                        title: 'Laser Therapy',
                        description:
                            'Thanks to modern laser technology, treatments at our practice are particularly gentle and cause little discomfort. Tooth decay can be removed precisely, often without the need for anesthesia.'
                    }
                }
            },

            serviceBanner: {
                title: 'Our Treatments at a Glance',
                description:
                    'Healthy teeth are an important part of your overall well-being. That is why we combine proven dental procedures with modern treatment methods and place great importance on careful diagnostics. Whether you need preventive care, tooth preservation, aesthetic dentistry or dental prosthetics, your individual needs are always at the center of our approach.',
                appointment: 'Book an appointment',
                imageAlt: 'Our dental treatments'
            },

            partners: {
                subTitle: 'Our Partners',
                title: 'Strong Partners for Your Smile',

                description:
                    'To help you achieve your best smile, we work with trusted partners from various fields of modern dentistry. Whether you are interested in modern orthodontics, professional teeth whitening or innovative laser technology, you can find an overview of our partners here.',

                items: {
                    claire: {
                        title: 'Model Claire Aligner',
                        description:
                            'Modern Claire aligners provide a discreet and comfortable way to straighten teeth – effective, precise, and suitable for everyday life.'
                    },

                    philips: {
                        title: 'Philips',
                        description:
                            'With Philips ZOOM!, we offer gentle professional teeth whitening for visibly brighter teeth – fast, safe and long-lasting.'
                    },

                    dmg: {
                        title: 'DMG',
                        description:
                            'Icon® caries infiltration gently treats white spots without drilling, pain or the need for anesthesia.'
                    },

                    biolase: {
                        title: 'Biolase',
                        description:
                            'The modern Waterlase iPlus Dental System enables particularly gentle and virtually painless treatments using innovative laser technology.'
                    }
                }
            },

            priority: {
                subTitle: 'OUR VALUES',
                title: 'Trust, Expertise and Quality for Your Smile',

                description:
                    'With our experience, modern technology and regular professional training, we make sure that you feel well cared for during every visit. Whether preventive care, tooth preservation, aesthetic dentistry or dental prosthetics – we support you with expertise and empathy on your way to a healthy and beautiful smile.\n\nTrust, openness and clear communication are our top priorities. We take the time to answer your questions and work with you to develop the right treatment plan.\n\nWe look forward to welcoming you to our practice!',

                appointment: 'Book an appointment',
                imageAlt: 'Our values'
            },

            more: {
                title: 'Would you like to know more?',
                description:
                    'Tatjana Pankraz, Sergey Lichagin and Alfiya Dyck are an experienced team and are happy to assist you with any questions you may have.',
                email: 'By email',
                phone: 'By phone',
                personal: 'In person at our practice',
                imageAlt: 'Our expert team'
            },

            gallery: {
                subTitle: 'A Look Inside Our Practice',
                title: 'Impressions of Our Practice',
                description:
                    'Discover our practice and get an impression of our modern treatment rooms, innovative technology and welcoming atmosphere.',
                imageAlt: 'Inside our dental practice'
            },

            footer: {
                description:
                    'Healthy teeth, a beautiful smile and personal care – this is what we stand for. We combine modern treatment methods with a welcoming atmosphere and take the time to understand your individual needs.',

                followUs: 'Follow us',
                contactTitle: 'Contact & Information',

                contacts: {
                    phoneEmail: {
                        title: 'Phone number and email'
                    },

                    openingHours: {
                        title: 'Opening hours',
                        info: 'Mon–Thu: 08:30–13:00 and 14:30–19:00, Fri: 08:30–14:00'
                    },

                    address: {
                        title: 'Address'
                    }
                },

                copyright: 'All rights reserved.',

                links: {
                    privacy: 'Privacy Policy',
                    imprint: 'Legal Notice',
                    cookies: 'Cookie Settings'
                }
            },
            faq: {
    title: 'Questions & Answers',

    description:
        'Here you will find answers to frequently asked questions about dental health, preventive care and our treatments.',

    items: [
        {
            question:
                'Why is professional dental cleaning useful if I take good care of my teeth at home?',
            answer:
                'Careful dental hygiene at home is the most important foundation for healthy teeth and gums. Nevertheless, there are areas that are difficult to clean completely even with good oral hygiene. During professional dental cleaning, we remove soft and hard deposits, including from hard-to-reach areas. This can reduce the risk of tooth decay and gum disease and support long-term oral health.'
        },

        {
            question:
                'How often should I have professional dental cleaning?',
            answer:
                'For many patients, an interval of around six months is appropriate. However, there is no universal schedule. In cases of gum disease, increased tartar formation, implants or certain types of dental restorations, shorter intervals – for example every three to four months – may be recommended. We will discuss the appropriate interval with you individually.'
        },

        {
            question:
                'Why do implants, crowns and bridges require particularly careful care?',
            answer:
                'Even high-quality dental restorations require consistent care. Bacterial deposits can accumulate particularly around transitions and hard-to-reach areas. Regular professional cleaning helps keep the gums and tissue around implants healthy and supports the long-term durability of your restoration.'
        },

        {
            question:
                'How much does professional dental cleaning cost?',
            answer:
                'Professional dental cleaning at our practice starts at 120 euros. The exact price depends on the condition of your teeth and gums, the amount of deposits and the individual treatment required.'
        },

        {
            question:
                'What types of fillings and restorations do you offer?',
            answer:
                'Depending on the dental situation, we use modern composite materials and ceramic restorations. For small and medium-sized defects, an aesthetic composite restoration can be very suitable. For larger defects, ceramic restorations can offer advantages in terms of stability and durability. We determine the appropriate treatment based on the affected tooth, the load, the size of the defect and your personal wishes.'
        },

        {
            question:
                'Which is better – composite or ceramic?',
            answer:
                'This depends on the individual situation. Modern composites allow for a conservative and aesthetic restoration. Ceramic restorations are particularly suitable when high stability, shape and colour stability, and long-term treatment of larger defects are required. Our goal is to preserve as much healthy tooth structure as possible and choose the solution that is medically appropriate for your tooth.'
        },

        {
            question:
                'How long do composite and ceramic restorations last?',
            answer:
                'The lifespan cannot be predicted exactly. It depends, among other things, on the size and location of the restoration, chewing forces, your oral hygiene and regular check-ups and preventive appointments. As a guideline, composite restorations can often last 5 to 10 years with good care, while ceramic restorations can last 10 to 15 years or longer.'
        },

        {
            question:
                'How much does a filling cost?',
            answer:
                'The cost depends on the size and location of the defect, the material used and the treatment required. The additional payment for a composite restoration starts at 20 euros, while ceramic treatment starts at 75 euros. Before treatment, we explain the available options and the associated costs.'
        },

        {
            question:
                'Why do I have to pay extra for some fillings?',
            answer:
                'Patients with statutory health insurance are entitled to treatment covered by statutory health insurance without additional payment. If you choose a more extensive or aesthetically advanced restoration that goes beyond the standard insurance benefit, additional costs may arise. We will discuss the alternatives and associated costs with you before treatment begins.'
        },

        {
            question:
                'When is root canal treatment necessary?',
            answer:
                'Root canal treatment may become necessary when the tissue inside a tooth is inflamed or infected. The aim is to eliminate the inflammation and preserve the natural tooth whenever possible. After careful diagnosis, we assess whether preserving the tooth is medically appropriate and promising in your individual case.'
        },

        {
            question:
                'How much does root canal treatment cost?',
            answer:
                'The cost depends in particular on the anatomy of the tooth, the number of root canals and the treatment required. As a guideline: 1 root canal from 200 euros; 3 or more root canals from 300 euros. After diagnosis, we can assess the required treatment more precisely and inform you about the expected costs in advance.'
        },

        {
            question:
                'When is an implant a good solution?',
            answer:
                'An implant can replace a missing tooth without having to grind down healthy neighbouring teeth. Implants can also provide a stable foundation for bridges or dentures. However, an implant is not automatically the best solution in every situation. We assess the condition of the neighbouring teeth, gums and jawbone and discuss possible alternatives with you.'
        },

        {
            question:
                'How much does a dental implant cost?',
            answer:
                'The cost of an implant at our practice starts at 1,200 euros. The final price depends on the individual situation, the available bone, any necessary preparatory procedures and the planned prosthetic restoration. Therefore, an exact cost estimate can only be prepared after examination and diagnosis. Before treatment begins, you will receive a transparent overview of the expected costs.'
        },

        {
            question:
                'When is a night guard useful?',
            answer:
                'People who strongly clench or grind their teeth at night can permanently overload and wear down their teeth. The chewing muscles and jaw joints can also be affected. A custom-made splint can protect the teeth and help distribute the load more evenly.'
        },

        {
            question:
                'What is the difference between a night guard and an adjusted splint?',
            answer:
                'The appropriate splint depends on your individual situation. An adjusted splint is specifically adapted to the contact points between the upper and lower jaw. It therefore not only acts as a protective layer between the teeth but also allows for more controlled distribution of the load. After examination, we can determine which type of splint therapy is appropriate for you. A custom-fitted splint is available from 60 euros.'
        },

        {
            question:
                'Will I know the treatment costs in advance?',
            answer:
                'Yes. For smaller treatments, we can explain the costs or possible additional payment directly. For more extensive treatments, we prepare an individual treatment and cost plan. It is important to us that you know not only what we recommend, but also why, what alternatives are available and what costs are involved. For amounts up to 150 euros, payment is made directly after treatment. For higher amounts, you can request an invoice for later payment.'
        },

        {
            question:
                'Can dental supplementary insurance cover my treatment costs?',
            answer:
                'Depending on the policy, supplementary dental insurance may partially or fully cover costs for professional dental cleaning, high-quality restorations, crowns, bridges, implants and other dental services. However, the benefits vary considerably. Reimbursement rates, annual limits, waiting periods and exclusions depend on your individual insurance contract. We therefore cannot provide a binding statement about the amount your insurance will actually reimburse.'
        },

        {
            question:
                'How can I find out what my insurance will cover before treatment?',
            answer:
                'For more extensive treatments, we can prepare a treatment and cost plan that you can submit to your insurance company before treatment begins. This allows you to clarify the expected reimbursement in advance and make your decision calmly. If you are considering taking out supplementary dental insurance, it is worth checking the policy conditions carefully: treatments that have already been recommended, planned or started are not covered, or are only covered to a limited extent, by many policies.'
        }
    ]
},
appointment: {
    map: {
        title: 'Google Maps',
        description:
            'To display the map, you need to enable Google Maps in the cookie settings.',
        cookieSettings: 'Cookie Settings'
    },

    form: {
        subTitle: 'Write to us',
        title: 'We are happy to help you with any questions',
        description:
            'If you have any questions, please feel free to contact us. Please fill in all the information below and submit the form. We will get back to you as soon as possible.'
    }
},
aboutBanner: {
    title: 'About us',

    description:
        'Welcome to the Pankraz & Lichagin dental practice! Our practice stands for modern dentistry, personal care and a pleasant atmosphere. Our goal is to provide every patient with individual treatment at the highest professional level.',

    button: 'Contact us!',

    imageAlt: 'Pankraz & Lichagin dental practice',

    imageAltTwo: 'Dental practice treatment rooms'
},
contactPage: {
    title: 'Contact us',

    description:
        'We are happy to help you. Whether you would like to make an appointment, have questions about our treatments or need help with a dental emergency – our team is here to support you professionally and personally. Get in touch with us – we look forward to hearing from you.',

    appointmentText:
        'Would you like to make an appointment directly?',

    appointmentTextSecond:
        'Simply use our online appointment booking.',

    appointmentButton:
        'Book an appointment now',

    formText:
        'Do you have any questions or would you prefer to contact us directly?',

    formTextSecond:
        'Feel free to use our contact form – we will get back to you as soon as possible.'
},
notFound: {
    subtitle: 'Page not found',

    title: 'This page could not be found.',

    description:
        'The page you are looking for does not exist or has been moved. Return to the homepage and discover our dental practice.',

    button: 'Back to homepage'
},
contactForm: {
    name: {
        label: 'First and last name',
        placeholder: 'Your name'
    },

    email: {
        label: 'Email address',
        placeholder: 'Your email address'
    },

    birthday: {
        label: 'Date of birth',
        placeholder: 'DD.MM.YYYY'
    },

    subject: {
        label: 'Subject',
        placeholder: 'Please select',

        options: {
            appointment: 'Appointment',
            treatment: 'Question about treatment',
            emergency: 'Emergency',
            costs: 'Cost inquiry',
            other: 'Other'
        }
    },

    message: {
        label: 'Message',
        placeholder: 'Write your message...'
    },

    sending: 'Sending...',

    send: 'Send message',

    successMessage:
        'Thank you! Your message has been sent successfully. We will get back to you as soon as possible.',

    errorMessage:
        'An error occurred while sending your message. Please try again later.'
},
cookies: {
    title: 'Cookie Settings',

    description:
        'We use cookies and similar technologies to keep our website secure and functional. Some external services are only loaded with your consent.',

    moreInfo:
        'For more information, please see our',

    privacy:
        'Privacy Policy',

    buttons: {
        necessary: 'Necessary only',
        settings: 'Settings',
        acceptAll: 'Accept all',
        save: 'Save selection'
    },

    settings: {
        alwaysActive: 'Always active',

        necessary: {
            title: 'Necessary Cookies',
            description:
                'These cookies are required for our website to function properly.'
        },

        googleMaps: {
            title: 'Google Maps',
            description:
                'Allows Google Maps and the location of our dental practice to be displayed.'
        },

        instagram: {
            title: 'Instagram',
            description:
                'Allows Instagram content to be displayed.'
        },

        tracking: {
            title: 'Statistics & Tracking',
            description:
                'Helps us understand how visitors use our website.'
        },

        marketing: {
            title: 'Marketing',
            description:
                'Allows the use of marketing and advertising services.'
        }
    }
},
datenschutz: {
    hero: {
        eyebrow: "Legal Information",
        title: "Privacy Policy",
        text: "The protection of your personal data is important to us. Here you can find information about how we handle your personal data."
    },

    sections: {
        responsible: {
            title: "1. Controller",
            intro: "The controller responsible for processing personal data on this website is:"
        },

        general: {
            title: "2. General Information",
            p1: "We treat your personal data confidentially and in accordance with the applicable data protection laws and this Privacy Policy.",
            p2: "Personal data is any information relating to an identified or identifiable person. This includes, for example, your name, email address, telephone number, IP address or other information that can be associated with you.",
            p3: "We process personal data only where this is necessary to provide a functional website, process your enquiries, fulfil legal obligations or on the basis of your consent."
        },

        website: {
            title: "3. Data Processing When Visiting Our Website",
            p1: "When you access our website, information is automatically transmitted to our website server by the browser you use.",
            intro: "The following data may in particular be processed:",
            items: {
                ip: "IP address of the accessing device",
                date: "Date and time of access",
                pages: "Web pages visited",
                browser: "Browser type and browser version",
                os: "Operating system",
                referrer: "Referrer URL",
                connection: "Technical connection data"
            },
            p2: "This data is processed in particular to ensure the technical provision, stability and security of our website.",
            legal: "The legal basis is Art. 6 para. 1 lit. f GDPR."
        },

        hosting: {
            title: "4. Hosting via ALL-INKL.COM",
            p1: "This website is hosted by ALL-INKL.COM – Neue Medien Münnich, owner René Münnich, Hauptstraße 68, 02742 Friedersdorf, Germany.",
            p2: "ALL-INKL.COM provides the technical infrastructure for operating our website. As part of the hosting, personal data that technically arises when visiting our website may be processed.",
            p3: "This may include, in particular, IP address, date and time of access, pages visited, browser information, operating system, referrer URL and technical connection data.",
            p4: "This data processing serves in particular the technical provision, stability and security of our website.",
            p5: "If ALL-INKL.COM processes personal data on our behalf, this is carried out on the basis of a data processing agreement pursuant to Art. 28 GDPR.",
            p6: "Data processing in connection with web hosting generally takes place in Germany. ALL-INKL.COM states that the data centre infrastructure used for web hosting is operated in Germany.",
            link: "ALL-INKL.COM Privacy Information"
        },

        contact: {
            title: "5. Contact",
            p1: "If you contact us by email, telephone or via our contact form, the personal data you provide will be processed insofar as this is necessary to process your enquiry.",
            intro: "This may include, in particular:",
            items: {
                name: "Name",
                email: "Email address",
                phone: "Telephone number",
                message: "Content of your message",
                time: "Time of contact"
            },
            p2: "The data is processed to handle and respond to your enquiry.",
            legal: "The legal basis is Art. 6 para. 1 lit. b GDPR if your enquiry is related to the initiation or performance of a contractual relationship. In other cases, processing is based on our legitimate interest pursuant to Art. 6 para. 1 lit. f GDPR."
        },

        contactForm: {
            title: "6. Contact Form",
            p1: "Our website provides the option of contacting us via a contact form.",
            p2: "The data you enter is processed to handle your enquiry and contact you.",
            p3: "Please do not submit unnecessary health data or other specially protected personal data via the general contact form.",
            p4: "According to Art. 9 GDPR, health data belongs to special categories of personal data and is subject to increased protection."
        },

        email: {
            title: "7. Technical Email Transmission",
            p1: "An external email service may be used for the technical transmission of messages submitted through our contact form.",
            p2: "If EmailJS is used for this purpose, the data entered into the contact form may be processed for the technical transmission of your message.",
            p3: "The processing is carried out exclusively to handle your contact enquiry."
        },

        googleMaps: {
            title: "8. Google Maps",
            p1: "Google Maps may be integrated into our website to display the location of our dental practice.",
            p2: "The provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.",
            p3: "When Google Maps is used, your IP address and other technical information may be transmitted to Google.",
            p4: "Google Maps is integrated to clearly display our location and make it easier for you to find your way to our practice.",
            p5: "Where legally required, Google Maps is only loaded after your consent.",
            link: "Google Privacy Policy"
        },

        instagram: {
            title: "9. Instagram",
            p1: "Our website contains a link to our Instagram profile.",
            p2: "Simply linking to Instagram generally does not result in personal data being transmitted to Instagram when you visit our website.",
            p3: "If you click the Instagram link, you will be redirected to Instagram. From that point onwards, the privacy provisions of the respective provider apply.",
            p4: "The provider of Instagram is Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland.",
            link: "Instagram Privacy Policy"
        },

        cookies: {
            title: "10. Cookies",
            p1: "Our website uses cookies and similar technologies where this is necessary for the operation of the website or legally permitted.",
            p2: "Cookies are small text files that may be stored on your device.",
            p3: "Technically necessary cookies may be required for our website to function properly.",
            p4: "For non-essential cookies and similar technologies, we obtain your consent in advance where legally required.",
            p5: "You can change your cookie settings at any time via the corresponding page on our website.",
            link: "Open Cookie Settings"
        },

        storage: {
            title: "11. Storage Period",
            p1: "We store personal data only for as long as necessary for the respective purpose or as required by statutory retention obligations.",
            p2: "Once the respective processing purpose no longer applies, the data will be deleted unless legal reasons require further storage."
        },

        rights: {
            title: "12. Your Rights",
            intro: "Within the scope of the applicable legal provisions, you have in particular the following rights:",
            items: {
                access: "Right of access",
                rectification: "Right to rectification",
                deletion: "Right to erasure",
                restriction: "Right to restriction of processing",
                portability: "Right to data portability",
                objection: "Right to object",
                withdrawal: "Right to withdraw consent"
            },
            p1: "If you wish to exercise your rights, you can contact us at any time using the contact details provided above."
        },

        complaint: {
            title: "13. Right to Lodge a Complaint with a Supervisory Authority",
            p1: "You have the right to lodge a complaint with a data protection supervisory authority if you believe that the processing of your personal data violates data protection regulations.",
            authority: "State Commissioner for Data Protection and Freedom of Information of North Rhine-Westphalia"
        },

        security: {
            title: "14. Data Security",
            p1: "We use appropriate technical and organisational security measures to protect your personal data against loss, destruction, manipulation or access by unauthorised persons.",
            p2: "Our security measures are regularly reviewed and adapted in accordance with technological developments and legal requirements."
        },

        externalLinks: {
            title: "15. External Links",
            p1: "Our website may contain links to external websites and online services of third parties.",
            p2: "We have no influence over the content or data processing on these external websites. The respective privacy policies of the operators apply to the processing of personal data by these providers."
        },

        changes: {
            title: "16. Changes to This Privacy Policy",
            p1: "We reserve the right to amend this Privacy Policy if the technical conditions of our website or legal requirements change.",
            p2: "The current version of this Privacy Policy is available on our website."
        }
    },

    updated: "Version: August 2026"
},
impressum: {
    title: "Legal Notice",

    ddg: {
        title: "Information pursuant to § 5 DDG"
    },

    contact: {
        title: "Contact",
        phone: "Tel: 0521-7708288",
        fax: "Fax: 0521-7708290",
        email: "Email: info@zahnarztpraxispankrazlichagin.com"
    },

    chamber: {
        title: "Competent Chamber",
        text: "Dental Association of Westphalia-Lippe"
    },

    approval: {
        title: "Country of Professional Admission",
        text: "Germany"
    },

    professionalRules: {
        title: "Professional Regulations",
        p1: "Professional regulations of the Dental Association of Westphalia-Lippe.",
        p2: "The professional regulations can be viewed on the website of the Dental Association of Westphalia-Lippe."
    },

    responsible: {
        title: "Responsible for Content"
    },

    vat: "We are not liable for value-added tax.",

    liability: {
        title: "Disclaimer",

        content: {
            title: "1. Content of the Online Offer",
            p1: "The website operator assumes no liability for the accuracy, completeness, timeliness or quality of the information provided. Liability claims against the website operator relating to material or immaterial damage caused by the use or non-use of the information provided or by the use of incorrect and incomplete information are generally excluded unless the website operator can be proven to have acted intentionally or with gross negligence.",
            p2: "All offers are non-binding. The website operator expressly reserves the right to change, supplement, delete or temporarily or permanently discontinue parts of the pages or the entire offer without prior notice."
        },

        links: {
            title: "2. References and Links",
            p1: "In the case of direct or indirect references to external websites (\"hyperlinks\") that are outside the responsibility of the website operator, liability would only arise if the website operator was aware of the content and it was technically possible and reasonable for the operator to prevent use in the event of illegal content.",
            p2: "The website operator expressly declares that no illegal content was recognisable on the linked pages at the time the links were created. The website operator has no influence on the current or future design, content or authorship of the linked pages.",
            p3: "The website operator therefore expressly distances itself from all content of linked pages that was changed after the link was created.",
            p4: "This statement applies to all links and references within the website as well as to external entries in guest books, discussion forums and mailing lists operated by the website operator.",
            p5: "For illegal, incorrect or incomplete content and, in particular, for damage arising from the use or non-use of such information, liability lies solely with the provider of the page referred to and not with the person who merely refers to the respective publication via links."
        }
    },

    copyright: {
        title: "3. Copyright and Trademark Law",
        p1: "The website operator endeavours to respect the copyrights of graphics, audio documents, video sequences and texts used in all publications, to use graphics, audio documents, video sequences and texts created by the operator or to use royalty-free materials.",
        p2: "The copyright for published objects created by the website operator remains solely with the website operator. Reproduction or use of such graphics, audio documents, video sequences and texts in other electronic or printed publications is not permitted without the express consent of the website operator.",
        p3: "The operator of this website is not responsible for direct or indirect damage caused to users or third parties through the use of this website."
    }
},


    whatsapp: {
        title: "Prefer WhatsApp?",
        description:
            "Do you have questions or would like to book an appointment? Contact us easily via our WhatsApp service.",
        instruction: "Scan the QR code to start a chat.",
        button: "Start WhatsApp chat",
        phoneLabel: "WhatsApp number",
        qrAlt: "QR code to open our WhatsApp chat"
    },


        }

    },























    ru: {
        translation: {
            navbar: {
                home: 'Главная',
                about: 'О нас',
                services: 'Услуги',
                contact: 'Контакты',
                faq: 'Частые вопросы',
                appointment: 'Связаться с нами'
            },

            banner: {
                title: 'Ваши стоматологи для современной стоматологии',
                description:
                    'Добро пожаловать в стоматологическую клинику Pankraz & Lichagin. Мы предлагаем протезирование с использованием имплантов, коронок и мостов, а также частичных и полных протезов. Эстетические процедуры и лечение пародонтита с помощью лазера дополняют спектр наших услуг.',
                appointment: 'Записаться на приём',
                emergency: 'Стоматологическая неотложная помощь',
                emergencyAlt: 'Неотложная стоматологическая помощь',
                imageAlt: 'Стоматологическая клиника'
            },

            services: {
                title: 'Наши услуги',

                description:
                    'От регулярных профилактических осмотров и профессиональной гигиены до более сложных стоматологических процедур — мы сопровождаем вас на каждом этапе лечения. Вместе с вами мы обсуждаем возможные варианты, подробно и понятно объясняем каждый этап и разрабатываем план лечения, который соответствует вашим индивидуальным потребностям и ожиданиям.',

                show: 'Показать все услуги',
                hide: 'Скрыть услуги',

                rootCanal: {
                    title: 'Лечение корневых каналов',
                    description:
                        'Лечение корневых каналов часто позволяет сохранить воспалённый или сильно повреждённый зуб. Корневые каналы тщательно очищаются, дезинфицируются и герметично заполняются.'
                },

                rootCanalRevision: {
                    title: 'Повторное лечение корневых каналов',
                    description:
                        'Если предыдущее лечение корневых каналов не дало желаемого результата, может потребоваться повторное лечение. При этом каналы обрабатываются заново, чтобы сохранить зуб на длительный срок.'
                },

                fillings: {
                    title: 'Лечение зубов пломбами',
                    description:
                        'Повреждённые или поражённые кариесом зубы восстанавливаются с помощью качественных пломбировочных материалов. Это позволяет восстановить функцию и внешний вид зуба.'
                },

                periodontitis: {
                    title: 'Лечение пародонтита',
                    description:
                        'Воспаление дёсен и тканей, окружающих зубы, лечится на ранней стадии, чтобы предотвратить потерю костной ткани и сохранить собственные зубы надолго.'
                },

                dentalProsthetics: {
                    title: 'Зубные протезы и конструкции',
                    description:
                        'Отсутствующие или сильно повреждённые зубы заменяются индивидуально подобранными конструкциями. Коронки, мосты и имплантаты обеспечивают естественную функцию и гармоничный внешний вид.'
                },

                dentures: {
                    title: 'Протезы',
                    description:
                        'Съёмные протезы являются надёжным решением при отсутствии нескольких зубов или всех зубов в челюсти. Современные протезы обеспечивают высокий комфорт и естественный внешний вид.'
                },

                splints: {
                    title: 'Зубные шины',
                    description:
                        'Индивидуально изготовленные зубные шины защищают зубы, например, при ночном скрежетании зубами, а также могут поддерживать работу височно-нижнечелюстных суставов.'
                },

                implants: {
                    title: 'Имплантация',
                    description:
                        'Имплантаты позволяют надёжно заменить отсутствующие зубы и служат основой для коронок, мостов или протезов. Они обеспечивают естественный внешний вид, комфорт и полноценную жевательную функцию.'
                },

                prophylaxis: {
                    title: 'Профилактика',
                    description:
                        'Регулярные профилактические осмотры и профессиональная чистка зубов помогают предотвратить кариес и заболевания пародонта. Благодаря этому зубы и дёсны остаются здоровыми надолго.'
                },

                orthodontics: {
                    title: 'Ортодонтия',
                    description:
                        'Ортодонтия занимается исправлением неправильного положения зубов и челюстей. Современные методы лечения помогают добиться правильного прикуса и гармоничной улыбки.'
                },

                moreTitle: 'Другие услуги',

                moreDescription:
                    'Помимо перечисленных процедур, мы предлагаем широкий спектр других стоматологических услуг. Мы с удовольствием проконсультируем вас лично и разработаем индивидуальный план лечения с учётом ваших потребностей.'
            },

            team: {
                subTitle: 'Наша команда',
                title: 'Познакомьтесь с нашей командой',

                description:
                    'Наша команда стоматологов и специалистов работает вместе, чтобы обеспечить вам качественное и внимательное лечение. Доброжелательность, профессионализм и индивидуальный подход являются для нас приоритетом, чтобы вы чувствовали себя комфортно с самого первого посещения.',

                members: {
                    tatjana: {
                        name: 'Татьяна Панкрац',
                        description:
                            'Более 20 лет работает стоматологом и обладает большим профессиональным опытом, особенно в области эстетической стоматологии.'
                    },

                    sergey: {
                        name: 'Сергей Лычагин',
                        description:
                            'Обладает многолетним профессиональным опытом и специализируется на лазерном лечении, лечении корневых каналов и имплантологии.'
                    },

                    alfiya: {
                        name: 'Альфия Дюк',
                        description:
                            'Специализируется на лечении и повторном лечении корневых каналов, а также на детской стоматологии.'
                    }
                }
            },

            smile: {
                title: 'Мы хотим, чтобы вы сияли.',
                description:
                    'Ваша улыбка особенно важна для нас. Поэтому мы предлагаем широкий спектр современных стоматологических процедур и помогаем вам в области эстетической стоматологии обрести здоровую, красивую и сияющую улыбку.',
                imageAlt: 'Красивая улыбка'
            },

            servicesPreview: {
                subTitle: 'Профилактика',
                title: 'Профилактика очень важна',

                description:
                    'Регулярные профилактические осмотры помогают нам лучше узнать вас как пациента и оценить состояние здоровья ваших зубов. Наш главный приоритет — своевременно выявлять заболевания и помогать вам сохранять здоровье полости рта.',

                more: 'Подробнее',

                items: {
                    dentalProsthetics: {
                        title: 'Зубные протезы',
                        description:
                            'Необходимость в зубном протезировании может возникнуть по разным причинам. Мы предлагаем индивидуальные решения, которые выглядят естественно и обеспечивают комфорт.'
                    },

                    aesthetics: {
                        title: 'Эстетическая стоматология',
                        description:
                            'Ваша красивая улыбка важна для нас! От отбеливания и ортодонтии до виниров и вкладок — мы предлагаем подходящие решения для вашей улыбки.'
                    },

                    prophylaxis: {
                        title: 'Профилактика',
                        description:
                            'Индивидуально подобранная профилактика помогает предотвратить негативное воздействие бактерий и сохранить здоровье зубов и дёсен на долгие годы.'
                    },

                    laserTherapy: {
                        title: 'Лазерная терапия',
                        description:
                            'Современная лазерная технология позволяет проводить лечение максимально щадяще и с минимальным дискомфортом. Кариес можно удалять очень точно, часто даже без анестезии.'
                    }
                }
            },

            serviceBanner: {
                title: 'Наши методы лечения',

                description:
                    'Здоровые зубы являются важной частью общего самочувствия. Поэтому мы сочетаем проверенные методы стоматологического лечения с современными технологиями и уделяем особое внимание тщательной диагностике. Независимо от того, нужна ли вам профилактика, лечение и сохранение зубов, эстетическая стоматология или протезирование, в центре нашего внимания всегда находятся ваши индивидуальные потребности.',

                appointment: 'Записаться на приём',
                imageAlt: 'Наши методы лечения'
            },

            partners: {
                subTitle: 'Наши партнёры',
                title: 'Надёжные партнёры для вашей улыбки',

                description:
                    'Чтобы помочь вам добиться красивой и здоровой улыбки, мы сотрудничаем с надёжными партнёрами в различных областях современной стоматологии. Современная ортодонтия, профессиональное отбеливание зубов или инновационные лазерные технологии — здесь вы можете ознакомиться с нашими партнёрами.',

                items: {
                    claire: {
                        title: 'Model Claire Aligner',
                        description:
                            'Современные элайнеры Claire позволяют незаметно и комфортно корректировать положение зубов — эффективно, точно и удобно в повседневной жизни.'
                    },

                    philips: {
                        title: 'Philips',
                        description:
                            'С помощью Philips ZOOM! мы предлагаем щадящее профессиональное отбеливание для заметно более светлых зубов — быстро, безопасно и с длительным эффектом.'
                    },

                    dmg: {
                        title: 'DMG',
                        description:
                            'Метод инфильтрации кариеса Icon® позволяет бережно устранить белые пятна на зубах без сверления, боли и анестезии.'
                    },

                    biolase: {
                        title: 'Biolase',
                        description:
                            'Современная система Waterlase iPlus Dental System позволяет проводить особенно щадящее и практически безболезненное лечение с использованием инновационной лазерной технологии.'
                    }
                }
            },

            priority: {
                subTitle: 'НАШИ ЦЕННОСТИ',
                title: 'Доверие, профессионализм и качество для вашей улыбки',

                description:
                    'Благодаря нашему опыту, современным технологиям и регулярному повышению квалификации мы заботимся о том, чтобы вы чувствовали себя комфортно во время каждого посещения. Профилактика, сохранение зубов, эстетическая стоматология или протезирование — мы сопровождаем вас профессионально и внимательно на пути к здоровой и красивой улыбке.\n\nДля нас особенно важны доверие, открытость и понятная консультация. Мы уделяем время вашим вопросам и вместе с вами подбираем подходящий план лечения.\n\nМы будем рады приветствовать вас в нашей клинике!',

                appointment: 'Записаться на приём',
                imageAlt: 'Наши ценности'
            },

            more: {
                title: 'Хотите узнать больше?',
                description:
                    'Татьяна Панкрац, Сергей Лычагин и Альфия Дюк — слаженная команда специалистов, которая с удовольствием ответит на все ваши вопросы.',
                email: 'По электронной почте',
                phone: 'По телефону',
                personal: 'Лично в нашей клинике',
                imageAlt: 'Наша команда специалистов'
            },

            gallery: {
                subTitle: 'Наша клиника',
                title: 'Фотографии нашей клиники',
                description:
                    'Познакомьтесь с нашей клиникой и получите представление о современных кабинетах, инновационном оборудовании и приятной атмосфере.',
                imageAlt: 'Интерьер стоматологической клиники'
            },

            footer: {
                description:
                    'Здоровые зубы, красивая улыбка и индивидуальный подход — это то, что является основой нашей работы. Мы сочетаем современные методы лечения с приятной атмосферой и уделяем внимание индивидуальным потребностям каждого пациента.',

                followUs: 'Мы в социальных сетях',
                contactTitle: 'Контакты и информация',

                contacts: {
                    phoneEmail: {
                        title: 'Телефон и электронная почта'
                    },

                    openingHours: {
                        title: 'Часы работы',
                        info: 'Пн–Чт: 08:30–13:00 и 14:30–19:00, Пт: 08:30–14:00'
                    },

                    address: {
                        title: 'Адрес'
                    }
                },

                copyright: 'Все права защищены.',

                links: {
                    privacy: 'Политика конфиденциальности',
                    imprint: 'Выходные данные',
                    cookies: 'Настройки Cookie'
                }
            },


            faq: {
    title: 'Вопросы и ответы',

    description:
        'Здесь вы найдете ответы на часто задаваемые вопросы о здоровье зубов, профилактике и наших методах лечения.',

    items: [
        {
            question:
                'Зачем нужна профессиональная чистка зубов, если я хорошо ухаживаю за зубами дома?',
            answer:
                'Тщательная гигиена зубов дома является важнейшей основой здоровья зубов и десен. Однако даже при хорошем уходе существуют участки, которые трудно полностью очистить самостоятельно. Во время профессиональной чистки мы удаляем мягкий и твердый налет, в том числе в труднодоступных местах. Это помогает снизить риск кариеса и заболеваний десен и поддерживать здоровье полости рта в долгосрочной перспективе.'
        },

        {
            question:
                'Как часто следует проходить профессиональную чистку зубов?',
            answer:
                'Для многих пациентов оптимальным является интервал около шести месяцев. Однако универсального графика не существует. При заболеваниях десен, повышенном образовании зубного камня, наличии имплантов или определенных видах зубных протезов могут быть рекомендованы более короткие интервалы, например каждые три-четыре месяца. Подходящий именно для вас интервал мы определяем индивидуально.'
        },

        {
            question:
                'Почему импланты, коронки и мосты требуют особенно тщательного ухода?',
            answer:
                'Даже качественные зубные конструкции требуют регулярного ухода. Особенно в местах соединений и труднодоступных участках могут скапливаться бактериальные отложения. Регулярная профессиональная чистка помогает сохранять здоровье десен и тканей вокруг имплантов и способствует длительной эксплуатации конструкции.'
        },

        {
            question:
                'Сколько стоит профессиональная чистка зубов?',
            answer:
                'Профессиональная чистка зубов в нашей клинике стоит от 120 евро. Точная стоимость зависит от состояния зубов и десен, количества отложений и индивидуального объема лечения.'
        },

        {
            question:
                'Какие пломбы и реставрации вы предлагаете?',
            answer:
                'В зависимости от состояния зуба мы используем современные композитные материалы и керамические реставрации. Для небольших и средних дефектов хорошо подходит эстетическая композитная реставрация. При более крупных дефектах керамическая реставрация может иметь преимущества благодаря своей прочности и долговечности. Подходящий вариант определяется индивидуально с учетом состояния зуба, нагрузки, размера дефекта и ваших пожеланий.'
        },

        {
            question:
                'Что лучше – композит или керамика?',
            answer:
                'Это зависит от конкретной ситуации. Современные композиты позволяют провести щадящую и эстетичную реставрацию. Керамические реставрации особенно подходят в случаях, когда необходимы высокая прочность, стабильность формы и цвета, а также долговременное восстановление больших дефектов. Наша цель – сохранить как можно больше здоровых тканей зуба и выбрать медицински подходящее решение.'
        },

        {
            question:
                'Как долго служат композитные и керамические реставрации?',
            answer:
                'Точный срок службы невозможно предсказать. Он зависит, среди прочего, от размера и расположения реставрации, жевательной нагрузки, гигиены полости рта и регулярных профилактических осмотров. В качестве ориентира композитные реставрации при хорошем уходе часто служат от 5 до 10 лет, а керамические – от 10 до 15 лет и дольше.'
        },

        {
            question:
                'Сколько стоит пломба?',
            answer:
                'Стоимость зависит от размера и расположения дефекта, используемого материала и необходимого объема лечения. Доплата за композитную реставрацию начинается от 20 евро, за керамическую – от 75 евро. До начала лечения мы объясним вам доступные варианты и связанные с ними расходы.'
        },

        {
            question:
                'Почему за некоторые пломбы нужно доплачивать?',
            answer:
                'Пациенты с обязательным медицинским страхованием имеют право на лечение, которое покрывается государственной системой страхования без дополнительной оплаты. Если пациент выбирает более сложную или эстетически улучшенную реставрацию, которая выходит за рамки стандартной страховой услуги, могут возникнуть дополнительные расходы. Все варианты и стоимость мы обсуждаем с вами до начала лечения.'
        },

        {
            question:
                'Когда необходимо лечение корневых каналов?',
            answer:
                'Лечение корневых каналов может потребоваться, если ткани внутри зуба воспалены или инфицированы. Цель лечения – устранить воспаление и по возможности сохранить собственный зуб. После тщательной диагностики мы оцениваем, возможно ли и целесообразно ли сохранить зуб в вашем конкретном случае.'
        },

        {
            question:
                'Сколько стоит лечение корневых каналов?',
            answer:
                'Стоимость зависит прежде всего от анатомии зуба, количества корневых каналов и объема лечения. Для ориентира: 1 корневой канал – от 200 евро; 3 и более корневых каналов – от 300 евро. После диагностики мы можем точнее определить необходимый объем лечения и заранее сообщить ожидаемую стоимость.'
        },

        {
            question:
                'Когда имплант является хорошим решением?',
            answer:
                'Имплант может заменить отсутствующий зуб без необходимости обтачивать здоровые соседние зубы. Импланты также могут служить надежной основой для мостов или протезов. Однако имплант не является автоматически лучшим решением в каждой ситуации. Мы оцениваем состояние соседних зубов, десен и костной ткани и обсуждаем с вами возможные альтернативы.'
        },

        {
            question:
                'Сколько стоит зубной имплант?',
            answer:
                'Стоимость импланта в нашей клинике начинается от 1 200 евро. Итоговая цена зависит от индивидуальной ситуации, имеющегося объема костной ткани, возможных подготовительных процедур и планируемого протезирования. Поэтому точный расчет стоимости можно составить только после обследования и диагностики. До начала лечения вы получите прозрачную информацию об ожидаемых расходах.'
        },

        {
            question:
                'Когда нужна капа от скрежетания зубами?',
            answer:
                'Если человек сильно сжимает или скрежещет зубами во сне, это может привести к постоянной перегрузке и износу зубов. Также может увеличиваться нагрузка на жевательные мышцы и суставы челюсти. Индивидуально изготовленная шина помогает защитить зубы и более равномерно распределить нагрузку.'
        },

        {
            question:
                'В чем разница между капой от скрежетания зубами и регулируемой шиной?',
            answer:
                'Подходящий тип шины зависит от индивидуальной ситуации. Регулируемая шина специально подгоняется под контакты между верхней и нижней челюстью. Она не только защищает зубы, но и позволяет более контролируемо распределять нагрузку. После обследования мы можем определить, какой вид лечения шиной подходит именно вам. Индивидуально изготовленная шина стоит от 60 евро.'
        },

        {
            question:
                'Узнаю ли я стоимость лечения заранее?',
            answer:
                'Да. При небольших процедурах мы можем сразу объяснить стоимость или возможную доплату. Для более сложного лечения мы составляем индивидуальный план лечения и расходов. Нам важно, чтобы вы знали не только то, что мы рекомендуем, но и почему, какие существуют альтернативы и сколько они стоят. При сумме до 150 евро оплата производится непосредственно после лечения. При более высокой сумме по вашему желанию можно получить счет для последующей оплаты.'
        },

        {
            question:
                'Может ли дополнительная стоматологическая страховка покрыть расходы на лечение?',
            answer:
                'В зависимости от тарифа дополнительная стоматологическая страховка может частично или полностью покрывать расходы на профессиональную чистку зубов, качественные реставрации, коронки, мосты, импланты и другие стоматологические услуги. Однако условия страхования значительно различаются. Размер возмещения, годовые лимиты, сроки ожидания и исключения зависят от вашего индивидуального договора. Поэтому мы не можем гарантировать, какую именно сумму возместит ваша страховая компания.'
        },

        {
            question:
                'Как узнать заранее, какую часть лечения оплатит моя страховка?',
            answer:
                'При более сложном лечении мы можем составить план лечения и расходов, который вы сможете предоставить своей страховой компании до начала лечения. Таким образом, вы сможете заранее уточнить предполагаемую сумму возмещения и спокойно принять решение. Если вы только рассматриваете оформление дополнительной стоматологической страховки, внимательно ознакомьтесь с условиями договора: уже рекомендованное, запланированное или начатое лечение во многих страховых тарифах не покрывается или покрывается только частично.'
        }
    ]
},
appointment: {
    map: {
        title: 'Google Maps',
        description:
            'Чтобы отобразить карту, необходимо включить Google Maps в настройках файлов cookie.',
        cookieSettings: 'Настройки файлов cookie'
    },

    form: {
        subTitle: 'Напишите нам',
        title: 'Мы будем рады помочь вам с любыми вопросами',
        description:
            'Если у вас есть вопросы, напишите нам. Пожалуйста, заполните всю информацию ниже и отправьте форму. Мы ответим вам как можно скорее.'
    }
},
aboutBanner: {
    title: 'О нас',

    description:
        'Добро пожаловать в стоматологическую клинику Pankraz & Lichagin! Наша клиника сочетает современную стоматологию, индивидуальный подход и приятную атмосферу. Наша цель — предоставить каждому пациенту индивидуальное лечение на самом высоком профессиональном уровне.',

    button: 'Связаться с нами!',

    imageAlt: 'Стоматологическая клиника Pankraz & Lichagin',

    imageAltTwo: 'Кабинеты стоматологической клиники'
},
contactPage: {
    title: 'Свяжитесь с нами',

    description:
        'Мы всегда рады вам помочь. Хотите записаться на приём, у вас есть вопросы о наших услугах или вам необходима срочная стоматологическая помощь — наша команда окажет вам компетентную и внимательную поддержку. Свяжитесь с нами — мы будем рады вашему сообщению.',

    appointmentText:
        'Хотите сразу записаться на приём?',

    appointmentTextSecond:
        'Просто воспользуйтесь нашей онлайн-записью.',

    appointmentButton:
        'Записаться на приём',

    formText:
        'У вас остались вопросы или вы предпочитаете написать нам напрямую?',

    formTextSecond:
        'Воспользуйтесь нашей контактной формой — мы ответим вам как можно скорее.'
},
notFound: {
    subtitle: 'Страница не найдена',

    title: 'Эта страница не найдена.',

    description:
        'Запрашиваемая страница не существует или была перемещена. Вернитесь на главную страницу и познакомьтесь с нашей клиникой.',

    button: 'На главную'
},
contactForm: {
    name: {
        label: 'Имя и фамилия',
        placeholder: 'Ваше имя'
    },

    email: {
        label: 'Электронная почта',
        placeholder: 'Ваш адрес электронной почты'
    },

    birthday: {
        label: 'Дата рождения',
        placeholder: 'ДД.ММ.ГГГГ'
    },

    subject: {
        label: 'Тема',
        placeholder: 'Выберите тему',

        options: {
            appointment: 'Запись на приём',
            treatment: 'Вопрос о лечении',
            emergency: 'Экстренная помощь',
            costs: 'Вопрос о стоимости',
            other: 'Другое'
        }
    },

    message: {
        label: 'Сообщение',
        placeholder: 'Напишите нам ваше сообщение...'
    },

    sending: 'Отправка...',

    send: 'Отправить сообщение',

    successMessage:
        'Спасибо! Ваше сообщение успешно отправлено. Мы свяжемся с вами как можно скорее.',

    errorMessage:
        'При отправке сообщения произошла ошибка. Пожалуйста, попробуйте ещё раз позже.'
},
cookies: {
    title: 'Настройки файлов cookie',

    description:
        'Мы используем файлы cookie и похожие технологии, чтобы обеспечить безопасность и корректную работу нашего сайта. Некоторые внешние сервисы загружаются только после вашего согласия.',

    moreInfo:
        'Дополнительную информацию вы найдёте в нашей',

    privacy:
        'Политике конфиденциальности',

    buttons: {
        necessary: 'Только необходимые',
        settings: 'Настройки',
        acceptAll: 'Принять все',
        save: 'Сохранить выбор'
    },

    settings: {
        alwaysActive: 'Всегда активно',

        necessary: {
            title: 'Необходимые файлы cookie',
            description:
                'Эти файлы cookie необходимы для корректной работы нашего сайта.'
        },

        googleMaps: {
            title: 'Google Maps',
            description:
                'Позволяет отображать Google Maps и местоположение нашей стоматологической клиники.'
        },

        instagram: {
            title: 'Instagram',
            description:
                'Позволяет отображать содержимое Instagram.'
        },

        tracking: {
            title: 'Статистика и отслеживание',
            description:
                'Помогает нам понять, как посетители используют наш сайт.'
        },

        marketing: {
            title: 'Маркетинг',
            description:
                'Позволяет использовать маркетинговые и рекламные сервисы.'
        }
    }
},
datenschutz: {
    hero: {
        eyebrow: "Правовая информация",
        title: "Политика конфиденциальности",
        text: "Защита ваших персональных данных важна для нас. Здесь вы можете узнать, как мы обрабатываем ваши персональные данные."
    },

    sections: {
        responsible: {
            title: "1. Ответственное лицо",
            intro: "Ответственным за обработку персональных данных на этом сайте является:"
        },

        general: {
            title: "2. Общая информация",
            p1: "Мы обрабатываем ваши персональные данные конфиденциально и в соответствии с действующим законодательством о защите данных и настоящей политикой конфиденциальности.",
            p2: "Персональные данные — это любые сведения, которые позволяют идентифицировать человека. К ним относятся, например, имя, адрес электронной почты, номер телефона, IP-адрес или другие сведения, которые могут быть связаны с конкретным человеком.",
            p3: "Мы обрабатываем персональные данные только в той мере, в которой это необходимо для обеспечения работоспособности сайта, обработки ваших запросов, выполнения юридических обязательств или на основании предоставленного вами согласия."
        },

        website: {
            title: "3. Обработка данных при посещении нашего сайта",
            p1: "При посещении нашего сайта используемый вами браузер автоматически передаёт информацию на сервер нашего сайта.",
            intro: "В частности, могут обрабатываться следующие данные:",
            items: {
                ip: "IP-адрес устройства",
                date: "Дата и время доступа",
                pages: "Посещённые страницы",
                browser: "Тип и версия браузера",
                os: "Операционная система",
                referrer: "URL источника перехода",
                connection: "Технические данные соединения"
            },
            p2: "Эти данные обрабатываются прежде всего для технического предоставления, стабильности и безопасности нашего сайта.",
            legal: "Правовым основанием является ст. 6 абз. 1 лит. f DSGVO."
        },

        hosting: {
            title: "4. Хостинг через ALL-INKL.COM",
            p1: "Этот сайт размещён у ALL-INKL.COM – Neue Medien Münnich, владелец René Münnich, Hauptstraße 68, 02742 Friedersdorf, Германия.",
            p2: "ALL-INKL.COM предоставляет техническую инфраструктуру для работы нашего сайта. В рамках хостинга могут обрабатываться персональные данные, которые технически возникают при посещении нашего сайта.",
            p3: "К ним, в частности, могут относиться IP-адрес, дата и время доступа, посещённые страницы, информация о браузере, операционная система, URL источника перехода и технические данные соединения.",
            p4: "Обработка этих данных служит прежде всего для технического предоставления, стабильности и безопасности нашего сайта.",
            p5: "Если ALL-INKL.COM обрабатывает персональные данные по нашему поручению, это осуществляется на основании соглашения об обработке данных в соответствии со ст. 28 DSGVO.",
            p6: "Обработка данных в рамках веб-хостинга, как правило, осуществляется в Германии. ALL-INKL.COM указывает, что инфраструктура дата-центров, используемая для веб-хостинга, находится в Германии.",
            link: "Информация о защите данных ALL-INKL.COM"
        },

        contact: {
            title: "5. Обращение к нам",
            p1: "Если вы связываетесь с нами по электронной почте, телефону или через контактную форму, предоставленные вами персональные данные обрабатываются в той мере, в которой это необходимо для обработки вашего запроса.",
            intro: "В частности, это могут быть:",
            items: {
                name: "Имя",
                email: "Адрес электронной почты",
                phone: "Номер телефона",
                message: "Содержание сообщения",
                time: "Время обращения"
            },
            p2: "Обработка осуществляется для обработки и ответа на ваш запрос.",
            legal: "Правовым основанием является ст. 6 абз. 1 лит. b DSGVO, если ваш запрос связан с заключением или исполнением договорных отношений. В остальных случаях обработка осуществляется на основании нашего законного интереса в соответствии со ст. 6 абз. 1 лит. f DSGVO."
        },

        contactForm: {
            title: "6. Контактная форма",
            p1: "На нашем сайте есть возможность связаться с нами через контактную форму.",
            p2: "Введённые вами данные обрабатываются для обработки вашего запроса и связи с вами.",
            p3: "Просим не передавать через общую контактную форму ненужные медицинские данные или другие особо защищённые персональные данные.",
            p4: "Согласно ст. 9 DSGVO медицинские данные относятся к особым категориям персональных данных и пользуются повышенной защитой."
        },

        email: {
            title: "7. Техническая отправка электронной почты",
            p1: "Для технической передачи сообщений из контактной формы может использоваться внешний сервис электронной почты.",
            p2: "Если для этой цели используется EmailJS, введённые вами в контактную форму данные могут обрабатываться для технической передачи вашего сообщения.",
            p3: "Обработка осуществляется исключительно для обработки вашего обращения."
        },

        googleMaps: {
            title: "8. Google Maps",
            p1: "На нашем сайте может быть интегрирован Google Maps для отображения местоположения стоматологической клиники.",
            p2: "Поставщиком является Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ирландия.",
            p3: "При использовании Google Maps ваш IP-адрес и другая техническая информация могут передаваться компании Google.",
            p4: "Google Maps используется для удобного отображения нашего местоположения и облегчения поиска маршрута до нашей клиники.",
            p5: "Если это предусмотрено законом, Google Maps загружается только после получения вашего согласия.",
            link: "Политика конфиденциальности Google"
        },

        instagram: {
            title: "9. Instagram",
            p1: "На нашем сайте имеется ссылка на наш профиль Instagram.",
            p2: "При простом размещении ссылки при посещении нашего сайта, как правило, персональные данные в Instagram не передаются.",
            p3: "Если вы нажмёте на ссылку Instagram, вы будете перенаправлены на Instagram. С этого момента действуют положения о защите данных соответствующего поставщика.",
            p4: "Поставщиком Instagram является Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ирландия.",
            link: "Политика конфиденциальности Instagram"
        },

        cookies: {
            title: "10. Файлы cookie",
            p1: "Наш сайт использует файлы cookie и аналогичные технологии в той мере, в которой это необходимо для работы сайта или разрешено законом.",
            p2: "Файлы cookie — это небольшие текстовые файлы, которые могут сохраняться на вашем устройстве.",
            p3: "Технически необходимые файлы cookie могут требоваться для корректной работы нашего сайта.",
            p4: "Для необязательных файлов cookie и аналогичных технологий мы, если это предусмотрено законом, предварительно запрашиваем ваше согласие.",
            p5: "Вы можете в любое время изменить настройки файлов cookie на соответствующей странице нашего сайта.",
            link: "Открыть настройки файлов cookie"
        },

        storage: {
            title: "11. Срок хранения данных",
            p1: "Мы храним персональные данные только до тех пор, пока это необходимо для соответствующей цели или пока существуют установленные законом обязательства по хранению.",
            p2: "После прекращения соответствующей цели обработки данные удаляются, если законодательные основания не требуют их дальнейшего хранения."
        },

        rights: {
            title: "12. Ваши права",
            intro: "В рамках действующего законодательства вы, в частности, имеете следующие права:",
            items: {
                access: "Право на получение информации",
                rectification: "Право на исправление",
                deletion: "Право на удаление",
                restriction: "Право на ограничение обработки",
                portability: "Право на переносимость данных",
                objection: "Право на возражение",
                withdrawal: "Право отозвать ранее предоставленное согласие"
            },
            p1: "Если вы хотите воспользоваться своими правами, вы можете в любое время связаться с нами по указанным выше контактным данным."
        },

        complaint: {
            title: "13. Право на подачу жалобы в надзорный орган",
            p1: "Вы имеете право обратиться с жалобой в орган по защите данных, если считаете, что обработка ваших персональных данных нарушает законодательство о защите данных.",
            authority: "Уполномоченный по защите данных и свободе информации земли Северный Рейн-Вестфалия"
        },

        security: {
            title: "14. Безопасность данных",
            p1: "Мы применяем соответствующие технические и организационные меры безопасности для защиты ваших персональных данных от потери, уничтожения, изменения или доступа неуполномоченных лиц.",
            p2: "Наши меры безопасности регулярно проверяются и адаптируются с учётом технического развития и требований законодательства."
        },

        externalLinks: {
            title: "15. Внешние ссылки",
            p1: "Наш сайт может содержать ссылки на внешние сайты и онлайн-предложения третьих лиц.",
            p2: "Мы не можем влиять на содержание и обработку данных на этих внешних сайтах. Для обработки персональных данных соответствующими поставщиками применяются их собственные положения о защите данных."
        },

        changes: {
            title: "16. Изменения настоящей политики конфиденциальности",
            p1: "Мы оставляем за собой право изменять настоящую политику конфиденциальности, если изменяются технические условия работы нашего сайта или требования законодательства.",
            p2: "Актуальная версия настоящей политики конфиденциальности доступна на нашем сайте."
        }
    },

    updated: "Версия: август 2026 года"
},
impressum: {
    title: "Выходные данные",

    ddg: {
        title: "Информация в соответствии с § 5 DDG"
    },

    contact: {
        title: "Контакты",
        phone: "Тел.: 0521-7708288",
        fax: "Факс: 0521-7708290",
        email: "Электронная почта: info@zahnarztpraxispankrazlichagin.com"
    },

    chamber: {
        title: "Ответственная палата",
        text: "Стоматологическая палата Вестфалии-Липпе"
    },

    approval: {
        title: "Государство выдачи разрешения на профессиональную деятельность",
        text: "Германия"
    },

    professionalRules: {
        title: "Профессиональные нормы",
        p1: "Профессиональные нормы Стоматологической палаты Вестфалии-Липпе.",
        p2: "С профессиональными нормами можно ознакомиться на сайте Стоматологической палаты Вестфалии-Липпе."
    },

    responsible: {
        title: "Ответственный за содержание"
    },

    vat: "Мы не являемся плательщиками налога с оборота.",

    liability: {
        title: "Отказ от ответственности",

        content: {
            title: "1. Содержание онлайн-предложения",
            p1: "Оператор сайта не гарантирует актуальность, правильность, полноту или качество предоставленной информации. Требования о возмещении материального или нематериального ущерба, возникшего в результате использования или неиспользования предоставленной информации либо использования ошибочной или неполной информации, как правило, исключаются, если со стороны оператора сайта не было доказано умышленное или грубо неосторожное нарушение обязанностей.",
            p2: "Все предложения являются необязательными. Оператор сайта оставляет за собой право без отдельного уведомления изменять, дополнять или удалять отдельные страницы либо всё предложение, а также временно или окончательно прекращать публикацию."
        },

        links: {
            title: "2. Ссылки",
            p1: "В случае прямых или косвенных ссылок на сторонние сайты (\"гиперссылок\"), которые находятся за пределами ответственности оператора сайта, ответственность может возникнуть только в том случае, если оператору сайта было известно о содержании и технически возможно и разумно предотвратить использование ссылки в случае незаконного содержания.",
            p2: "Оператор сайта прямо заявляет, что на момент размещения ссылок на связанных страницах не было обнаружено незаконного содержания. Оператор сайта не имеет влияния на текущее или будущее оформление, содержание или авторство связанных страниц.",
            p3: "Поэтому оператор сайта прямо дистанцируется от всего содержания связанных страниц, которое было изменено после размещения ссылки.",
            p4: "Это положение распространяется на все ссылки и указания, размещённые на данном сайте, а также на сторонние записи в гостевых книгах, дискуссионных форумах и списках рассылки, созданных оператором сайта.",
            p5: "За незаконное, ошибочное или неполное содержание и, в частности, за ущерб, возникший в результате использования или неиспользования такой информации, несёт ответственность исключительно оператор страницы, на которую ведёт ссылка, а не лицо, которое лишь ссылается на соответствующую публикацию."
        }
    },

    copyright: {
        title: "3. Авторское право и право на товарные знаки",
        p1: "Оператор сайта стремится соблюдать авторские права на используемые в публикациях графические материалы, аудиозаписи, видеоматериалы и тексты, использовать материалы, созданные самостоятельно, либо материалы, свободные от лицензионных ограничений.",
        p2: "Авторские права на опубликованные объекты, созданные оператором сайта самостоятельно, остаются исключительно за оператором сайта. Воспроизведение или использование таких графических материалов, аудиозаписей, видеоматериалов и текстов в других электронных или печатных публикациях без специального разрешения оператора сайта не допускается.",
        p3: "Оператор данного сайта не несёт ответственности за прямой или косвенный ущерб, который может возникнуть у пользователей или третьих лиц в результате использования данного сайта."
    }
},


    whatsapp: {
        title: "Предпочитаете WhatsApp?",
        description:
            "У вас есть вопросы или вы хотите записаться на приём? Свяжитесь с нами через WhatsApp.",
        instruction: "Отсканируйте QR-код, чтобы начать чат.",
        button: "Открыть чат в WhatsApp",
        phoneLabel: "Номер WhatsApp",
        qrAlt: "QR-код для перехода в наш чат WhatsApp"
    },

        }
    }
};

export default translations;